import logo from '../assets/sacredrelm_logo.png';
import slider1 from '../assets/main/banner4.webp'
import slider2 from '../assets/main/banner5.webp'
import slider3 from '../assets/main/banner1.webp'
import slider4 from '../assets/main/banner2.webp'
import home_second from '../assets/main/img4.webp';
import homethree1 from '../assets/main/sree dhana laxmi akarsha pack/laxmi_idol1.webp'
import homethree2 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/7.webp'
import homethree3 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/sree_anjaneya_shani_raksha.webp'
import faq from '../assets/main/img3.webp';
import aboutdesign from '../assets/home/about.webp';
import design from '../assets/home/thirddesign.svg';
import test1 from '../assets/home/testimonial-1.png';
import test2 from '../assets/home/testimonial-2.png';
import test3 from '../assets/home/testimonial-3.png';
import test4 from '../assets/home/testimonial-4.png';
import test5 from '../assets/home/testimonial-5.png';
import test6 from '../assets/home/testimonial-6.webp';
import test7 from '../assets/home/testimonial-7.webp';
import test8 from '../assets/home/testimonial-8.webp';
import test9 from '../assets/home/testimonial-9.webp';
import test10 from '../assets/home/testimonial-10.webp';
import contact from '../assets/contact/contact.webp';
import product1 from '../assets/main/Ashta laxmi Yantras/sree_astha_laxmi.webp';
import productal13 from '../assets/main/Ashta laxmi Yantras/sree_astha_laxmi1.webp';
// import productal11 from '../assets/main/Ashta laxmi Yantras/1.webp';
import product3 from '../assets/main/Ashta laxmi Yantras/lakshmi_gold_coin2.webp';
import product4 from '../assets/main/Ashta laxmi Yantras/sree_astha_lakshmi_devi_locket3.webp';
import product5 from '../assets/main/Ashta laxmi Yantras/kuber_kunji4.webp';
import product7 from '../assets/main/Ashta laxmi Yantras/meru_shri_yantram6.webp';
import product8 from '../assets/main/Ashta laxmi Yantras/gold_plated_chain7.webp';
import product20 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/sree_anjaneya_shani_raksha.webp';
import product21 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/sree_anjaneya_shani_raksha1.webp';
import product23 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/shri_hanuman_chalisa_yantra_locket1.webp';
import product24 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/sree_anjaneya_gada3.webp';
import product26 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/gurrapu_nada4.webp';
import product27 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/shani_yantra_kawach_locket5.webp';
import product28 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/rudraksha6.webp';
import product29 from '../assets/main/Sri Anjaneya Shani Raksha Yantras/meru_sriyantram10.webp';
import product30 from '../assets/main/sree dhana laxmi akarsha pack/sree_dhana_laxmi_akarsha.webp';
import product10 from '../assets/main/sree dhana laxmi akarsha pack/sree_dhana_laxmi_akarsha3.webp';
import product31 from '../assets/main/sree dhana laxmi akarsha pack/sree_dhana_laxmi_akarsha1.webp';
import product11 from '../assets/main/sree dhana laxmi akarsha pack/laxmi_idol1.webp'
import product12 from '../assets/main/sree dhana laxmi akarsha pack/laxmi_charan_paduka2.webp'
import product13 from '../assets/main/sree dhana laxmi akarsha pack/shree_yantra_wall_hanging3.webp'
import product14 from '../assets/main/sree dhana laxmi akarsha pack/lakshmi_gold_coin4.webp';
import product15 from '../assets/main/sree dhana laxmi akarsha pack/kuber_key5.webp';
import product16 from '../assets/main/sree dhana laxmi akarsha pack/meru_sriyantram6.webp';
import product42 from '../assets/main/product/sree_astha_lakshmi_devi_locket.webp';
import product44 from '../assets/main/product/meru_ring4.webp';
import product47 from '../assets/main/product/meru_sriyantram7.webp';
import product48 from '../assets/main/product/sree_anjaneya_gada8.webp';
import product50 from '../assets/main/product/shri_hanuman_chalisa_yantra_locket10.webp';
import product52 from '../assets/main/product/shree_yantra_wall_hanging12.webp';
import product61 from '../assets/main/product/21.webp';
import product67 from '../assets/main/product/shri_hanuman_chalisa_yantra_locket30.webp';
import product68 from '../assets/main/product/meru_ring31.webp';
import product70 from '../assets/main/product/sree_anjaneya_gada33.webp';
import product71 from '../assets/main/product/34.webp';
import product72 from '../assets/main/product/gurrapu_nada35.webp';
import product75 from '../assets/main/product/38.webp';
import product76 from '../assets/main/product/sree_astha_lakshmi_devi_locket39.webp';
import product78 from '../assets/main/product/41.webp';
import product82 from '../assets/main/product/44.webp';
import product84 from '../assets/main/product/shree_yantra_wall_hanging47.webp';
import product87 from '../assets/main/product/50.webp';
import product88 from '../assets/main/product/51.webp';
import product89 from '../assets/main/product/shri_hanuman_chalisa_yantra_locket52.webp';
import product91 from '../assets/main/product/meru_ring54.webp';
import product92 from '../assets/main/product/meru_ring55.webp';
import product93 from '../assets/main/product/56.webp';
import product96 from '../assets/main/product/shree_yantra_wall_hanging59.webp';
import product98 from '../assets/main/product/karungali_mala1.webp';
import product99 from '../assets/main/product/karungali_mala2.webp';
import product100 from '../assets/main/product/karungali_mala3.webp';
import product101 from '../assets/main/product/karungali_mala4.webp';
import product103 from '../assets/main/product/karungali_mala5.webp';
import product106 from '../assets/main/product/pyrite_hanuman_ji_on_selenite_frame76.webp';
import product107 from '../assets/main/product/shree_yantra_on_raw_pyrite_frame77.webp';
import product108 from '../assets/main/product/vyapar_vridhhi_yantra_on_raw_pyrite_frame78.webp';
import product109 from '../assets/main/product/7_horses_on_raw_pyrite_frame79.webp';
import blog1 from '../assets/main/blog/1.webp';




 
const translations = {
    home: {
        logo: logo,
        links: [
            {
                title: 'Home',
                url: '/'
            },
            {
                title: 'Shop',
                url: '/shop',
            },
            {
                title: 'Karungali',
                url: '/karungalimala',
            },
            {
                title: 'About',
                url: '/about'
            },
            {
                title: 'Contact',
                url: '/contact'
            },
            {
                title: 'Blogs',
                url: '/blog'
            }
        ],
        header: {
            short1: "Divine Protection",
            title1: 'Sacred Idols for Your Home',
            subtitle1: `“Abhayam sattva-samshuddhir” — Bhagavad Gita 16.1. Invite fearlessness and purity into your home with our protective idols.`,        
            short2: "Spiritual Blessings",
            title2: 'Experience Divine Grace',
            subtitle2: `“Yogaḥ karmasu kauśalam” — Bhagavad Gita 2.50. Embrace prosperity and harmony through devoted action and divine blessings.`,            
            short3: "Sacred Energy",
            title3: 'Transform Your Sacred Space',
            subtitle3: `“Shraddhavan labhate jnanam” — Bhagavad Gita 4.39. With faith, bring home divine energy that enlightens your space and soul.`,            
            button1: 'Shop Now',
            sider1img: slider2,
            sider2img: slider1,
            sider3img: slider3,
            sider4img: slider4,

        },
        second: {
            short: "Special Offerings",
            title: "Invite Blessings, Wealth & Protection",
            subtitle: `Bring home the protective grace of Sree Anjaneya Shani Raksha, inspired by Lord Hanuman’s unwavering devotion and strength in the Ramayana — shielding your family from hardships and negative forces. As a special blessing, receive a sacred Meru Ring **FREE** with your order — symbolizing steady growth and prosperity, much like the divine Kurma (tortoise incarnation) from the ancient scriptures. Welcome the Sree Astha Laxmi Dhana Akarsha Yantra to honor the abundant blessings of Goddess Lakshmi, filling your home with wealth, happiness, and enduring good fortune. Let these timeless legends enrich your life today.`,
            button: "Shop Now",
            image: home_second,
            design: aboutdesign,
        },        
        third: {
            design: design,
            image1: homethree1,
            title1: "Sacred Idols for Your Home",
            subtitle1: `“Abhayam sattva-samshuddhir” — Bhagavad Gita 16.1. Invite fearlessness and purity into your home with our protective idols.`,
            image2: homethree2,
            title2: "Experience Divine Grace",
            subtitle2: `“Yogaḥ karmasu kauśalam” — Bhagavad Gita 2.50. Embrace prosperity and harmony through devoted action and divine blessings.`,
            image3: homethree3,
            title3: "Transform Your Sacred Space",
            subtitle3: `“Shraddhavan labhate jnanam” — Bhagavad Gita 4.39. With faith, bring home divine energy that enlightens your space and soul.`,
        },        
        fourth: {
            short: "Our Collection",
            title: 'Bhagavad Gita’s Divine Inspirations',
            sub: "Explore timeless spiritual idols and energy tools inspired by the teachings — each crafted to nurture inner peace, abundance, and dharma in daily life.",
            card: "Add Cart",
            buy: "Buy Now",
        },
        cartitle: "Premium Spiritual Idols",
        catsub: "Sacred Ritual & Puja Collections",
        categories: ['All', 'Sree Anjaneya', 'Sree Astha Laxmi', 'Balaji', 'Durga', 'Ek Onkar', 'Khanda', 'Krishna', 'Laxmi', 'Saibaba'],
        faqtitle: "Expert Guidance",
        faqsub: "Your Questions Answered",
        images: faq,
        faqs: [
            {
                "question": "What are the benefits of these spiritual products?",
                "answer": "Each item in this sacred collection serves a unique purpose: from attracting wealth and prosperity with Shree Yantra and Lakshmi figurines to providing protection and positive energy through Rudraksha pendants, orgonite pyramids, and engraved pendants like the Shivaji Maharaj."
            },
            {
                "question": "Are these products suitable for home puja, meditation, or gifting?",
                "answer": "Yes! All these items are thoughtfully designed for daily puja, meditation, spiritual healing, and also make meaningful gifts for festivals, housewarmings, or special occasions."
            },
            {
                "question": "How should I place or wear these sacred products?",
                "answer": "Idols and yantras should be placed in clean, sacred spots like a home altar, puja room, or workspace in recommended directions (northeast is ideal). Pendants can be worn daily for personal protection and blessings."
            },
            {
                "question": "Are these items energized or blessed before delivery?",
                "answer": "Yes. All our products are carefully crafted and energized through traditional Vedic rituals to ensure they carry positive vibrations and divine blessings."
            },
            {
                "question": "Can I buy these spiritual products online and get doorstep delivery?",
                "answer": "Absolutely! You can safely order all our spiritual idols, yantras, and pendants online through our secure website. We offer fast and reliable doorstep delivery across India and abroad."
            }
        ],        
        reviews: [
            {
                name: "Rajesh",
                date: "27 June 2023",
                rating: 5,
                review: "The Sree Anjaneya idol brings such positive energy to our home. Excellent craftsmanship and divine detailing — truly blessed to have it! Ever since we placed it in our puja room, we feel a sense of protection and courage in facing daily challenges. It's a wonderful addition for anyone seeking spiritual peace.",
                image: test1,
            },
            {
                name: "Lakshmi",
                date: "26 June 2023",
                rating: 5,
                review: "Sree Astha Laxmi idol, we feel abundance and good fortune flowing into our family business. The idol’s presence has uplifted our daily prayers and created a calm, prosperous atmosphere at home. The quality is premium, and it arrived beautifully packed with clear care instructions.",
                image: test2,
            },
            {
                name: "Saraswathi",
                date: "29 June 2023",
                rating: 4,
                review: "Beautifully crafted idols with intricate designs. Fast shipping and well-packed. I placed them in my meditation space, and they truly enhance the sacredness of the room. The detailing is impressive, and I appreciate the divine vibrations these idols bring. Will surely order again for gifting to loved ones.",
                image: test3,
            },
            {
                name: "Srinivasan",
                date: "15 June 2023",
                rating: 3,
                review: "Absolutely beautiful and brings a calm, uplifting presence to my study room. It inspires me every day during reading and writing. The packaging could be a bit more secure to avoid minor scratches, but the piece itself is flawless and worth every penny. Highly recommended for students and anyone seeking knowledge and focus.",
                image: test4,
            },
            {
                name: "Raghavendra",
                date: "10 May 2023",
                rating: 5,
                review: "I ordered the Sree Anjaneya Shani Raksha for my parents — they love it! We feel so much peace and protection at home now. The idol has a strong spiritual aura and looks exactly as shown on the website. Delivery was on time, and it was packed with great care. Highly recommended for family well-being.",
                image: test5,
            },        
            {
                name: "Meenakshi",
                date: "02 August 2023",
                rating: 5,
                review: "I purchased the Divine Lakshmi Figurine with Mantra Base for my pooja room. The idol is beautifully detailed and radiates a divine aura. I feel a sense of calmness and blessings every time I offer prayers. Highly satisfied with this sacred addition.",
                image: test6,
            },
            {
                name: "Sowmya",
                date: "18 June 2023",
                rating: 4,
                review: "The Trishul Om Rudraksha Pendant is very powerful. I wear it daily and feel protected from negative thoughts and energies. The quality of the rudraksha beads and the trishul is excellent. Packaging was secure and delivery was prompt.",
                image: test7,
            },
            {
                name: "Anusha",
                date: "09 June 2023",
                rating: 5,
                review: "Absolutely love the Shree Yantra Orgonite Energy Pyramid! It’s placed in my office desk and I can feel a significant improvement in focus and positive vibes. The design is mesmerizing and it draws everyone’s attention. Worth every rupee spent.",
                image: test8,
            },
            {
                name: "Annapurna",
                date: "20 May 2023",
                rating: 4,
                review: "Ordered the Sree Dhana Laxmi Akarsha Pack as a gift for my brother. He wears it with pride every day. The engraving is clear and detailed, representing the spirit of Sree Dhana Laxmi Akarsha Pack beautifully. Happy with the purchase and the customer service too.",
                image: test9,
            },
            {
                name: "Revathi",
                date: "12 May 2023",
                rating: 5,
                review: "This Sacred Collection is truly divine. Every item I have ordered so far has exceeded my expectations in terms of quality and spiritual impact. My home feels more peaceful and prosperous. Thank you for delivering authentic spiritual products with so much care.",
                image: test10,
            },
        ]        
    },
    footerConfig: {
        contact: {
            logo: logo,
            title: "Contact Info",
            address: "Hyderabad, Telangana 500016",
            email: "customercareproductcenter@gmail.com",
            phone: "+91 9059 821 555"
        },
        usefulLinks: {
            title: "Useful Links",
            links: [
                { name: "Home", url: "/" },
                { name: "Shop", url: "/shop" },
                { name: "Karungali", url: "/karungalimala" },
                // { name: "Astrology", url: "https://sriastroveda.com" },
                { name: "About", url: "/about" },
                { name: "Help", url: "/contact" },
                { name: "Blogs", url: "/blog" },
            ]
        },
        bottomSection: {
            copyright: "All Right Reserved © {year} ISRAELITES SHOPPING NETWORK PRIVATE LIMITED",
            terms: {
                text: "Terms & Conditions",
                url: "/terms",
                text2: "Privacy Policy",
                url2: "/privacy",
                text3: "Return Policy",
                url3: "/return",
                text4: "Shipping Policy",
                url4: "/shipping",
                text5: "Cancellation Policy",
                url5: "/cancellation",

            }
        }
    },
    about: {
        title: 'About',
        subtitle: 'HOME > ABOUT',
        second: {
            short: "About Us",
            title: 'Discover Spiritual Artifacts That Inspire Serenity',
            subtitle: `Our collection of divine statues and spiritual artifacts is crafted to promote peace, mindfulness, and inner harmony. We bring you premium products that resonate with cultural and spiritual values.`,
            button: 'Shop Now',
            linkbutton: '/shop',
            design: aboutdesign,
        },
        short2: 'Our Mission',
        title2: "Celebrating Spiritual Heritage",
        sub2: `We aim to connect people with their spiritual roots through beautifully handcrafted statues and ritual products. Our offerings reflect devotion, artistry, and timeless traditions.`,
    },
    contact: {
        title: 'Contact',
        subtitle: 'HOME > CONTACT',
        second: {
            short: "Contact Us",
            title: 'Get In Touch With Us',
            subtitle: `Scelerisque fermentum dui faucibus in. Integer malesuada nunc vel risus commodo viverra maecenas accumsan lacus. Neque aliquam vestibulum blandit.`,
        },
        section: {
            title: "Our Branches",
            sub: "Et odio pellentesque diam volutpat. Adipiscing diam donec adipiscing tristique risus. Turpis massa sed elementum tempus egestas sed.",
            branches: [
                { title: 'India', address: 'Hyderabad, Telangana', phone: '+91 9059 821 555' },
            ]
        },
        submit: {
            title: "Hello! Welcome to Sacred Relm",
            img: contact,
            short: "Contact Us",
            title2: "Have Question? Get in Touch!",
            button: "Get In Touch"
        }
    },
    checkout: {
        title: "Checkout",
        order: "Order Summary",
        total: "Total",
        product: "Product",
        subtotal: "Subtotal",
        shipping: "Shipping",
        successfully: "Order Placed Successfully!",
        orderNumber: "Order Number",
        thank: "Thank you for your purchase!",
        continue: "Continue Shopping",
        sectitle: "Billing Details",
        firstname: "First Name",
        lastname: "Last Name",
        country: "Country",
        address: "Street Address",
        clientaddress: "Apartment, suite, etc. (optional)",
        city: "Town / City",
        phone: "Phone",
        email: "Email",
        processing: "Processing...",
        order: "Place Order",
        mode: "Payment Mode"
    },
    products: {
        categories: ['Idols'],
        cat: "Category",
        product: [
            {
                id: 5,
                category: 'Spiritual Accessories',
                cost: 2490,
                rating: 4.9,
                isNew: true,
                name: 'Sacred Karungali Twin Blessings Set',
                slug: 'sacred-karungali-mala',
                cod: true, 
                online: true,
                photo: { 
                    image1: product99,
                    image2: product100,
                    image3: product101,
                    image4: product98,
                    image5: product103,
                },
                description: "This exclusive combo of Sacred Karungali Mala and Karungali Bracelet made from pure Black Ebony, holds divine energy that removes negativity and brings positivity into your life.",
                metaTitle: "Karungali Twin Blessings Set | Spiritual Protection Beads",
                metaDescription: "Experience divine protection and positive energy with the original Sacred Karungali mala with Twin Blessings Set. This offers strength, clarity, and spiritual safety.",
                focusKeyword: "Karungali mala",
                tags: ["Karungali beads", "Twin blessings set", "Sacred Relm products", "Original Karungali mala"],
                fullDescription: `
                    This exclusive combo of {Sacred Karungali Mala} and {Karungali Bracelet} made from pure Black Ebony, holds divine energy that removes negativity and brings positivity into your life. 
                    ## Karungali Mala Description 
                    The Sacred {Karungali Mala} is made from pure Black Ebony tree, a wood that has been considered sacred for centuries in Indian traditions. Long ago, sages and saints used Karungali malas during meditation and prayers to stay protected from negative energies and to stay close to the divine. Each bead carries positive energy, making it a source of peace, strength, and spiritual guidance for anyone who wears it.
                    ##History of  Original Karungali Mala
                    Karungali, also called Black Ebony, has a long history in Vedic culture. It was used in prayers, rituals, and sacred ceremonies to ward off negativity and evil energies. The mala is believed to bring divine protection, balance, and blessings, connecting the wearer to ancient traditions of devotion and spirituality.
                `,
                benefits: [
                    "Protection from Negativity: Shields you from the evil eye and harmful energies",
                    "Peace and Strength: Brings calmness, courage, and emotional balance",
                    "Spiritual Growth: Helps during meditation, prayer, and self-reflection",
                    "Prosperity and Positivity: Attracts good fortune, positive energy, and blessings",
                    "Mental Clarity: Clears the mind and strengthens focus in daily life"
                ],
                howToUse: [
                    "Wear the original sacred karungali mala around your neck or wrist for daily protection and positivity",
                    "Use it during meditation or prayer to feel closer to the divine",
                    "Keep it in your pooja room or sacred space to enhance the energy around you",
                    "Gift it to loved ones to share blessings, protection, and positivity"
                ],
                faqs: [
                    {
                        question: "Who can wear karungali mala?",
                        answer: "Anyone seeking protection, spiritual growth, or relief from negative energy or planetary doshas can wear it."
                    },
                    {
                        question: "How to identify real karungali mala?",
                        answer: "Real Karungali beads are dense, smooth, and dark black in color with a slight natural wood grain. They feel heavy for their size and won't easily chip or break."
                    },
                    {
                        question: "What is the use of karungali mala?",
                        answer: "Karungali Mala is used for protection from negative energy, enhancing spiritual growth, calming the mind, and balancing body energies during prayer or meditation."
                    },
                    {
                        question: "Can I eat non-veg while wearing karungali mala?",
                        answer: "It is traditionally advised to avoid non-veg, alcohol, and tobacco while wearing Karungali Mala to maintain its spiritual purity and effectiveness."
                    },
                    {
                        question: "Can karungali mala be worn during periods?",
                        answer: "Traditionally, it is advised to avoid wearing Karungali Mala during menstruation out of respect for its spiritual purity, though this may vary based on personal belief or tradition."
                    }
                ],
                reviews: [
                    { 
                        id: 1,
                        // image: test1, 
                        user: 'Priya Narayanan', 
                        rating: 5, 
                        comment: "After wearing this Karungali mala and bracelet, I feel so peaceful da! The energy is something divine… feels like blessings from the temple itself.", 
                        date: '2024-07-10' 
                    },
                    { 
                        id: 2, 
                        // image:test2,
                        user: 'Suresh Raman', 
                        rating: 5, 
                        comment: "Namma oorla we say Karungali protects from drishti — I can truly feel that! Since I started wearing, my mind feels calm and focused. Super quality!", 
                        date: '2024-08-02' 
                    },
                    { 
                        id: 3, 
                        // image:test3,
                        user: 'Anjali Reddy', 
                        rating: 5, 
                        comment: "Bought this Twin Blessings Set for my amma. She said it gives her manasukku peace every morning. Very pure vibration!", 
                        date: '2024-09-05' 
                    },
                    { 
                        id: 4, 
                        // image:test4,
                        user: 'Raghav Iyer', 
                        rating: 4, 
                        comment: "Beads are smooth and original Karungali wood. Slight delay in courier, but product is 100% worth the wait macha!", 
                        date: '2024-10-01' 
                    },
                    { 
                        id: 5, 
                        // image:test5,
                        user: 'Meenakshi Pillai', 
                        rating: 5, 
                        comment: "Real spiritual feel! From the day I started using this, my pooja room feels more powerful. Ithuvum oru divine blessing dha!", 
                        date: '2024-09-20' 
                    },
                    { 
                        id: 6, 
                        user: 'Vignesh K', 
                        rating: 5, 
                        comment: "Wearing both mala and bracelet daily. I feel very positive — like god’s protection is always with me. Must buy anna!", 
                        date: '2024-08-27' 
                    },
                    { 
                        id: 7, 
                        user: 'Lakshmi Menon', 
                        rating: 5, 
                        comment: "Nalla quality product. Karungali beads are original — dark black, heavy, and sacred. My meditation energy improved a lot!", 
                        date: '2024-09-15' 
                    },
                    { 
                        id: 8, 
                        user: 'Manoj Kumar', 
                        rating: 4, 
                        comment: "It’s very nice product, feels divine every time I wear it. Delivery took 2 days extra, but product superu!", 
                        date: '2024-08-18' 
                    },
                    { 
                        id: 9, 
                        user: 'Sneha Krishnan', 
                        rating: 5, 
                        comment: "This mala gives so much shanti da. My morning prayer feels complete only after wearing it. Blessings to the makers!", 
                        date: '2024-09-25' 
                    },
                    { 
                        id: 10, 
                        user: 'Ramesh Chandran', 
                        rating: 5, 
                        comment: "Genuine Karungali set. My appa also started wearing it now. Brings calmness and protection — feels like positive aura around home.", 
                        date: '2024-10-03' 
                    }
                ]
            },
            {
                id: 10,
                category: 'Yantras',
                cost: 890,
                rating: 4.7,
                isNew: true,
                name: 'Meru Ring – Get Meru Ring Free',
                slug: 'meru-ring',
                cod: true,
                online: true,
                photo: {
                    image1: product68,
                    image2: product44,
                    image3: product91,
                    image4: product92
                },
                description: "Embrace divine blessings with the Meru Ring – Buy 1 Get 1 Free. Symbol of stability, prosperity, and positive energy for you and your loved ones.",
                metaTitle: "Meru Ring - Buy 1 Get 1 Free | SacredRelm",
                metaDescription: "Shop the Meru Ring for spiritual balance and energy healing. Special offer at SacredRelm: Buy one, get one free. Elevate your spiritual balance and positivity.",
                focusKeyword: "Meru Ring",
                tags: ["Sacred Relm Meru ring", "Meru ring free offer", "Spiritual ring buy 1 get 1"],
                fullDescription: `
                    The {Meru Ring}, also called the {Tortoise Ring}, is a special spiritual ring known for bringing luck, wealth, peace, and protection. It is based on Mount Meru and the Kurma Avatar of Lord Vishnu, where the tortoise carried Mount Meru during the Samudra Manthan. This is why the Meru Ring is also known as a symbol of stability and strength.
                    In Vastu, wearing a {Tortoise Ring} helps in attracting positive energy, good fortune, and success in life. It is said to protect the wearer from negative energy, financial loss, and mental stress. The ring supports spiritual growth and keeps the mind calm and focused.
                    People who wear the {Meru Ring} believe it improves luck, wealth, happiness, and peace of mind. It is also considered a good remedy for planetary imbalances and brings prosperity at home and work.
                    If you are looking for a lucky ring for wealth and protection, the Meru - Tortoise Ring is one of the best choices. It connects your energy with the divine power of Lord Vishnu and helps you stay strong, balanced, and successful in life.
                `,
                benefits: [
                    "Attracts positive energy, good fortune, and success in life",
                    "Protects from negative energy, financial loss, and mental stress",
                    "Supports spiritual growth and keeps the mind calm and focused",
                    "Improves luck, wealth, happiness, and peace of mind",
                    "Good remedy for planetary imbalances and brings prosperity"
                ],
                howToUse: [
                    "Wear on the right-hand ring finger for men and left-hand ring finger for women",
                    "Remove before bathing or sleeping to maintain sacred vibrations",
                    "Keep it clean by gently wiping with a dry cloth",
                    "Meditate or pray while wearing it to amplify positive energies",
                    "Can also be kept in your wallet or cash box when not worn"
                ],
                faqs: [
                    {
                        question: "What are the benefits of the Meru ring?",
                        answer: "SacredRelm Meru Ring offers protection from negative energy, enhances spiritual strength, and promotes balance, focus, and positive vibrations in daily life."
                    },
                    {
                        question: "Which finger is good for a Meru ring?",
                        answer: "The Meru Ring is usually worn on the right-hand ring finger for men and the left-hand ring finger for women to enhance energy flow and spiritual benefits."
                    },
                    {
                        question: "Is it good to wear a Meru ring?",
                        answer: "Yes, wearing a SacredRelm Meru Ring is believed to attract positive energy, protect against negativity, and support spiritual and mental balance."
                    },
                    {
                        question: "Which rashi people can wear a Meru ring?",
                        answer: "The Meru Ring is not limited to any specific Rashi and can be worn by people of all zodiac signs for protection, positive energy, and spiritual growth."
                    },
                    {
                        question: "What is the reason for wearing a Meru ring?",
                        answer: "The Meru Ring is worn to protect against negative energy, enhance spiritual vibrations, and bring balance, clarity, and positive transformation in life."
                    }
                ],
                freeAccessories: [
                    { 
                        name: "Meru Ring", 
                        image: product68, 
                        description: "Get an additional Meru Ring absolutely free with your purchase." 
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Lakshmi Sundaram",
                    rating: 5,
                    date: "2024-12-10",
                    comment: "Very nice product! I am wearing this Meru ring daily after doing pooja. My husband also got one free, so both of us are using. Feeling very peaceful and positive vibes in home."
                    },
                    {
                    id: 2,
                    user: "Venkatesh Iyer",
                    rating: 4.7,
                    date: "2024-11-22",
                    comment: "Good quality ring. I bought for my wife during Diwali time. She is very happy."
                    },
                    {
                    id: 3,
                    user: "Meena Ramachandran",
                    rating: 4.8,
                    date: "2024-10-15",
                    comment: "My mother-in-law suggested to wear this Meru ring. After wearing, I can see changes in my life. Money problems are reducing slowly. Thank God!"
                    },
                    {
                    id: 4,
                    user: "Krishnan Pillai",
                    rating: 5,
                    date: "2024-09-28",
                    comment: "Excellent product! Buy 1 get 1 free is very good offer. Gave one to my sister for Pongal gift. Both of us are experiencing positive energy and prosperity."
                    },
                    {
                    id: 5,
                    user: "Divya Subramanian",
                    rating: 4.6,
                    date: "2024-08-14",
                    comment: "Very nice Meru ring. I keep it in my purse when not wearing. My business is picking up slowly. Will recommend to all my relatives."
                    }
                ],
            },
            {
                id: 1,
                category: "Divine Frames",
                cost: 1790,
                rating: 4.8,
                isNew: true,
                name: "7 Horses on Raw Pyrite Frame",
                slug: "7-horses-raw-pyrite-frame",
                cod: true,
                online: true,
                photo: {
                    image1: product109
                },
                description: "The 7 Horses on Raw Pyrite Frame is a special wall decor that brings good luck, energy, and success into your home or office. This beautiful frame combines the power of seven horses and raw pyrite to inspire growth, positivity, and harmony in your space.",
                metaTitle: "7 Horses on Raw Pyrite Frame | SacredRelm",
                metaDescription: "Enhance your space with SacredRelm 7 Horses on Raw Pyrite a symbol of power, success, and energy. A perfect Vastu decor piece for home, office, or gifting.",
                focusKeyword: "Raw Pyrite frame",
                tags: ["7 Horses Frame", "Raw Pyrite Frame", "Spiritual Wall Frame", "SacredRelm Pyrite frame"],
                fullDescription: `
                    The {7 Horses on Raw Pyrite Frame} is a decorative and spiritual wall hanging. It combines the power of the seven horses of the Sun God (Surya Dev) with pyrite, known for attracting wealth and abundance. This wall art is believed to bring success, career growth, prosperity, and positive energy to your home or office. The seven horses symbolize speed, power, and victory, while the pyrite frame acts as a “money magnet”. Many people use it as a Vastu and Feng Shui remedy, placing it in the south, east, or north of a room to enhance energy flow and ensure fast progress.
                `,
                benefits: [
                    "Brings success and prosperity into your life",
                    "Attracts wealth and abundance",
                    "Creates positive energy and harmony in the space",
                    "Encourages progress, motivation, and confidence",
                    "Protects against negative energy",
                    "Makes a beautiful and meaningful decor piece"
                ],
                placement: [
                    "Home: Hang in the living room, study, or entrance hall to attract positive energy and prosperity",
                    "Office: Place on the wall behind your desk or in the reception area for success in career and business",
                    "Vastu Tip: Make sure it faces the entrance or is in a north, east, or northeast direction, as these directions bring wealth and growth energy"
                ],
                faqs: [
                    {
                        question: "Do's & Don'ts of 7 Horses on Raw Pyrite Frame?",
                        answer: "Do's: Place in East or North Wall for success and positive energy (per Vastu Shastra). Keep in a clean space like living rooms or offices. Don'ts: Avoid placing in bedrooms or bathrooms. Don't place on the floor or near shoes. Avoid broken or damaged frames."
                    },
                    {
                        question: "Are these frames suitable for gifting?",
                        answer: "Yes, 7 Horses on Raw Pyrite Frames make excellent gifts for housewarmings, business openings, or special occasions, as they symbolize success, prosperity, and positive energy."
                    },
                    {
                        question: "Are there any side effects of seven horses?",
                        answer: "No, there are no side effects if placed correctly. However, placing them in the wrong direction (like south or bedroom) may reduce their positive impact or cause energetic imbalance."
                    },
                    {
                        question: "How can 7 horses improve finances?",
                        answer: "The 7 Horses symbolize speed, progress, and success; when placed in the right direction, they help remove financial blockages and attract growth and prosperity."
                    },
                    {
                        question: "Where not to put it?",
                        answer: "Avoid placing the 7 Horses in the bedroom, bathroom, kitchen, or south-facing walls, as these locations can reduce their positive energy and intended effects."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Arjun Reddy",
                    rating: 5,
                    date: "2025-06-15",
                    comment: "Superb frame! Placed it in my office cabin facing east direction as per Vastu. Clients are coming more nowadays. Very happy with purchase."
                    },
                    {
                    id: 2,
                    user: "Priya Narasimhan",
                    rating: 4.8,
                    date: "2025-05-20",
                    comment: "Beautiful 7 horses frame with pyrite stones. Hanged in our living room after Diwali pooja. Family members are all saying positive energy is there in house now."
                    },
                    {
                    id: 3,
                    user: "Raghavan Nair",
                    rating: 4.7,
                    date: "2025-04-10",
                    comment: "My wife selected this for our new home. After keeping this, we are getting good fortune. Business deals are also coming smoothly. Worth the money!"
                    },
                    {
                    id: 4,
                    user: "Kavitha Balasubramanian",
                    rating: 5,
                    date: "2025-03-18",
                    comment: "Very powerful frame! I gifted to my brother for his shop inauguration. He called me and said business is running very well. Thank you SacredRelm!"
                    },
                    {
                    id: 5,
                    user: "Srinivas Rao",
                    rating: 4.6,
                    date: "2025-02-25",
                    comment: "Quality is very good. Pyrite stones are shining nicely. Placed in north direction in drawing room. Feeling very positive changes in career growth."
                    }
                ]
            },
            {
                id: 2,
                category: "Divine Frames",
                cost: 1290,
                rating: 4.6,
                isNew: true,
                name: "Shree Yantra on Raw Pyrite Frame",
                slug: "Shree-Yantra-Raw-Pyrite-Frame",
                cod: true,
                online: true,
                photo: {
                    image1: product107
                },
                description: "Shree Yantra is one of the most auspicious and powerful yantras, known for attracting wealth, success, and harmony. Mounted on raw pyrite, this sacred geometric design not only amplifies prosperity but also protects your space from negative energies, creating a balanced and positive environment.",
                fullDescription: `
                    The Shree Yantra on Raw Pyrite Frame is a powerful spiritual and decorative item that brings wealth, success, and harmony to your home or office. The Shree Yantra is a sacred geometric symbol that represents Goddess Lakshmi and cosmic energy, while the raw Pyrite frame is known to attract money, luck, and protect against negative energy. Together, they create a strong energy tool to improve your life.
                    ##What’s Special About It?
                    The Shree Yantra on Raw Pyrite Frame is a powerful combination of sacred energy and wealth-attracting properties. The Shree Yantra is a sacred geometric design linked to Goddess Lakshmi, and it is believed to remove obstacles, bring success, and increase positive energy. The raw Pyrite frame is known as a Stone of Wealth. It can attract money, good luck, and success, while also protecting your home or office from negative energy. The golden shine of Pyrite amplifies the energy of the Shree Yantra, making this combination even more powerful for wealth, harmony, and positive energy.

                `,
                benefits: [
                    "Attracts money and prosperity for home or office",
                    "Protects from negative energy and bad influences",
                    "Brings peace and harmony in your space",
                    "Improves focus and confidence for work and life",
                    "Supports spiritual growth and positive energy"
                ],
                placement: [
                    "Best in the South-East corner (Wealth corner) of your home or office",
                    "Can also go in the North-East or East, following Vastu or Feng Shui rules"
                ],
                metaTitle: "Shree Yantra on Raw Pyrite Frame | Wealth & Harmony",
                metaDescription: "Bring harmony and abundance into your space with SacredRelm Shree Yantra on Raw Pyrite. A powerful Vastu decor piece for wealth, protection, and spiritual growth.",
                tags: ["shree yantra", "pyrite yantra frame", "shree yantra pyrite frame", "vastu shree yantra"],
                reviews: [
                    {
                    id: 1,
                    user: "Kamala Krishnan",
                    rating: 4.8,
                    date: "2025-07-05",
                    comment: "Placed this Shree Yantra in our pooja room after doing abhishekam. Whole family is feeling peaceful atmosphere. Financial problems are also reducing."
                    },
                    {
                    id: 2,
                    user: "Murali Venkatesh",
                    rating: 5,
                    date: "2025-08-18",
                    comment: "Very auspicious yantra! My pandit ji suggested to keep in southeast corner. After that, business growth is happening steadily. Highly satisfied!"
                    },
                    {
                    id: 3,
                    user: "Saroja Ramamurthy",
                    rating: 4.7,
                    date: "2025-09-02",
                    comment: "Beautiful craftsmanship with pyrite frame. We worship this daily during morning pooja. Lakshmi ji blessings are coming to our home. Very grateful!"
                    },
                    {
                    id: 4,
                    user: "Sunita Verma",
                    rating: 5,
                    date: "2025-05-22",
                    comment: "Looks divine and feels very powerful. Excellent purchase. The energy in our home has improved significantly since we installed this."
                    },
                    {
                    id: 5,
                    user: "Rajesh Kumar",
                    rating: 5,
                    date: "2025-06-10",
                    comment: "The pyrite frame gives it a premium look. My office energy has improved significantly. Worth every rupee spent on this yantra!"
                    }
                ]
            },
            {
                id: 3,
                category: "Divine Frames",
                cost: 1490,
                rating: 4.7,
                isNew: true,
                name: "Vyapar Vridhhi Yantra on Raw Pyrite Frame",
                slug: "Vyapar-vridhi-yantra",
                cod: true,
                online: true,
                photo: {
                    image1: product108
                },
                description: "Vyapar Vriddhi Yantra on Raw Pyrite Frame is also called Shree Arthik Samriddhi Yantra. It is a special Vastu and Feng Shui tool used to bring business growth, money, and success. This yantra combines the power of Pyrite, known as the 'Stone of Wealth', with the Vyapar Vriddhi Yantra, which helps attract money, remove obstacles, and bring good luck in business and finances.",
                metaTitle: "Vyapar Vriddhi Yantra on Raw Pyrite Frame | SacredRelm",
                metaDescription: "Vyapar Vriddhi Yantra on raw pyrite helps attract wealth, remove business hurdles, and align your space with Vastu for continued success and profit.",
                focusKeyword: "Vyapar Vridhdi Yantra",
                tags: ["vyapar vriddhi yantra", "vastu yantra for business", "pyrite yantra frame", "Yantra Pyrite frame"],
                fullDescription: `
                    Vyapar Vriddhi Yantra on Raw Pyrite Frame is a sacred tool used in Vastu Shastra and Feng Shui to bring business growth, wealth, and prosperity. It is also called Shree Arthik Samriddhi Yantra. This powerful yantra combines the energy of Pyrite, known as the "Stone of Wealth", with the Vyapar Vriddhi Yantra, which is specially designed to help businesses succeed and remove obstacles.

                    ## History of Vyapar Vriddhi Yantra
                    - The Vyapar Vriddhi Yantra comes from ancient Vedic tradition in India.
                    - "Vyapar Vriddhi" means growth in business in Sanskrit.
                    - It has been used for centuries by traders, business owners, and professionals to attract money, prosperity, and success.
                    - Pyrite, the frame of this yantra, has been known since ancient times as a wealth-attracting stone.

                    ## What is it made of?
                    1. {Vyapar Vriddhi Yantra} - A sacred geometric symbol designed to bring business success and remove financial obstacles.
                    2. {Raw Pyrite Frame} - Pyrite enhances the yantra’s energy, attracting money, opportunities, and good luck.
                `,
                benefits: [
                    "Boosts Business Growth: Helps increase sales, turnover, and profits",
                    "Attracts Wealth: Draws money, clients, and new opportunities",
                    "Removes Obstacles: Clears negative energy and financial blockages in business",
                    "Creates Positive Energy: Promotes a peaceful and prosperous environment in your office or shop",
                    "Focus and Decision Making: Helps business owners and professionals make better choices",
                    "Supports Financial Stability: Brings long-term income and stability"
                ],
                howToUse: [
                    "Placement: Place the yantra in the northeast direction of your office, shop, or workspace for best results",
                    "Daily Rituals: Light a diya (lamp) and incense stick in front of the yantra",
                    "Offerings & Mantras: Offer fresh flowers and chant mantras such as 'Om Shreem Maha Lakshmiyei Namaha' or 'Om Namo Bhagavate Vasudevaya'",
                    "Maintenance: Keep the yantra clean and dust-free. Handle it with respect to maintain its spiritual energy",
                    "Additional Tips: Place it near cash counters, office desks, or main entrances. Avoid placing it in corners where energy feels blocked or dark"
                ],
                faqs: [
                    {
                        question: "What is the purpose of a Vyapar Vriddhi Yantra?",
                        answer: "The Vyapar Vriddhi Yantra is designed to attract business growth, increase profits, remove obstacles, and bring success and prosperity to entrepreneurs and traders."
                    },
                    {
                        question: "Is Vyapar Vriddhi Yantra the same as Shree Arthik Samriddhi Yantra?",
                        answer: "Both yantras aim to attract financial prosperity, but Vyapar Vriddhi Yantra specifically focuses on business growth, while Shree Arthik Samriddhi Yantra targets overall financial abundance and wealth."
                    },
                    {
                        question: "Should it face a particular direction?",
                        answer: "Yes, it is best placed facing east or north to maximize positive energy and attract business growth and prosperity."
                    },
                    {
                        question: "Why is Pyrite called the 'Stone of Wealth'?",
                        answer: "Pyrite is called the 'Stone of Wealth' because it is believed to attract abundance, prosperity, and positive energy, helping to remove financial blocks and stimulate growth."
                    },
                    {
                        question: "Can I give it as a gift to someone?",
                        answer: "Yes, Pyrite makes a thoughtful and powerful gift symbolizing wealth, protection, and positive energy for loved ones."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Ramesh Chetty",
                    rating: 5,
                    date: "2025-06-12",
                    comment: "My textile shop sales were dropping. After placing this Vyapar Vriddhi Yantra near cash counter, customers are increasing. Very effective yantra!"
                    },
                    {
                    id: 2,
                    user: "Padmini Srinivasan",
                    rating: 4.7,
                    date: "2025-05-08",
                    comment: "Bought for my husband's business. He keeps it in his office cabin. New orders are coming regularly now. We are very happy with results!"
                    },
                    {
                    id: 3,
                    user: "Gopal Menon",
                    rating: 4.8,
                    date: "2025-04-20",
                    comment: "Superb yantra for business growth! I do pooja every Friday morning. My trading business is flourishing. Profits are increasing month by month."
                    },
                    {
                    id: 4,
                    user: "Lalitha Narayanan",
                    rating: 5,
                    date: "2025-03-15",
                    comment: "My father started new medical shop. We placed this yantra after Ganapathi pooja. Sales are very good from day one itself. Blessed product!"
                    },
                    {
                    id: 5,
                    user: "Kiran Sharma",
                    rating: 4.5,
                    date: "2025-07-01",
                    comment: "I placed it in my shop, and business has picked up significantly. The quality of the frame is also very good."
                    }
                ]
            },
            {
                id: 4,
                category: "Divine Frames",
                cost: 1490,
                rating: 4.7,
                isNew: true,
                name: "Pyrite Hanuman Ji on Selenite Frame",
                slug: "Sacredrelm-Hanuman-Pyrite-on-Selenite-frame",
                cod: true,
                online: true,
                photo: {
                    image1: product106
                },
                description: "A beautiful Hanuman Ji made of pyrite, full of energy and power. The white selenite frame brings peace and purity. Together, they make a strong and calm energy. Perfect for your home temple or meditation space bringing good energy and blessings.",
                metaTitle: "Hanuman Pyrite on Selenite frame | SacredRelm",
                metaDescription: "Pyrite Hanuman Ji on a selenite frame removes negativity, and enhances Vastu alignment. A perfect blend of divine energy, protection, and spiritual decor.",
                focusKeyword: "Hanuman Pyrite on Selenite frame",
                tags: ["hanuman ji pyrite frame", "pyrite hanuman ji", "hanuman ji selenite frame", "Hanuman pyrite frame"],
                fullDescription: `
                    Invite divine strength and peaceful energy into your space with this beautifully crafted Pyrite Hanuman Ji on Selenite Frame. Hanuman Ji, the symbol of devotion, courage, and protection, is carved from natural pyrite stone, known for its powerful and grounding energy. Pyrite is believed to protect against negative energies, boost confidence, and bring mental clarity.
                    Together, pyrite and selenite create a strong yet soothing energy field making this piece ideal for
                    - Your home altar or puja room
                    - A meditation space or yoga corner
                    - A gift for loved ones seeking spiritual growth and positivity
                    - Vastu or energy balancing in your living or work space
                    Each piece is handcrafted and unique, blending sacred symbolism with the natural beauty . Whether you are a devotee of Hanuman Ji or simply looking for a meaningful spiritual decor item, this frame offers both blessings and beauty.
                `,
                benefits: [
                    "Brings Strength and Protection",
                    "Promotes Peace and Mental Clarity",
                    "Cleanses Negative Energies",
                    "Enhances Spiritual Connection",
                    "Improves Focus and Confidence",
                    "Meaningful Gift for Loved Ones",
                    "Perfect for Home, Office, or Temple"
                ],
                placement: [
                    "Place in your puja room, meditation corner, or home altar for spiritual connection",
                    "Keep in living room or study area for positive energy and focus",
                    "Ideal for office desk to promote confidence and mental clarity",
                    "Best placed where you want positive energy, peace, and protection"
                ],
                faqs: [
                    {
                        question: "Where should I place it in my home?",
                        answer: "You can place it in your puja room, meditation corner, living room, study area, or office desk. It's best placed where you want positive energy, focus, and peace."
                    },
                    {
                        question: "What are the spiritual benefits of this piece?",
                        answer: "Pyrite is known for strength, protection, and confidence, while selenite offers peace, cleansing, and clarity. Together, they create a balanced energy ideal for meditation, prayer, and Vastu."
                    },
                    {
                        question: "Can this piece help with stress and anxiety?",
                        answer: "Many users find the calming energy of selenite combined with the grounding power of pyrite helpful for reducing stress, clearing negative thoughts, and promoting emotional balance."
                    },
                    {
                        question: "Can I give it as a gift to someone?",
                        answer: "It's a meaningful and spiritual gift for occasions like housewarming, birthdays, festivals Diwali, Ram Navami, or spiritual milestones."
                    },
                    {
                        question: "Can I use it for meditation or healing?",
                        answer: "Yes, this piece is perfect for spiritual practices, chakra healing, reiki, and meditation. Selenite helps clear energy, while pyrite keeps you grounded and focused."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Suresh Pillai",
                    rating: 5,
                    date: "2025-07-14",
                    comment: "Jai Hanuman! This frame is amazing. I recite Hanuman Chalisa daily in front of it. Feeling mental peace and courage to face all obstacles."
                    },
                    {
                    id: 2,
                    user: "Geetha Balakrishnan",
                    rating: 4.8,
                    date: "2025-06-22",
                    comment: "Very powerful Hanuman Ji idol! Selenite base is very pure white color. Keeping in our temple room. All negative energies are cleared from house."
                    },
                    {
                    id: 3,
                    user: "Venkatesan Iyer",
                    rating: 5,
                    date: "2025-05-30",
                    comment: "My son was having some problems. After we installed this Hanuman ji frame and did Hanuman pooja, problems are solving. Very blessed to have this!"
                    },
                    {
                    id: 4,
                    user: "Radha Sundaram",
                    rating: 4.7,
                    date: "2025-04-18",
                    comment: "Beautiful Hanuman Ji with pyrite. We light lamp daily in front. Family health and harmony improved a lot. Hanuman Ji's blessings are with us!"
                    },
                    {
                    id: 5,
                    user: "Ankit Yadav",
                    rating: 5,
                    date: "2025-08-01",
                    comment: "The energy of this Hanuman Ji frame is truly powerful and protective. Highly recommend for Hanuman devotees!"
                    }
                ]
            },
            {
                id: 6,
                category: 'Idols',
                cost: 1590,
                rating: 4,
                isNew: false,
                name: 'Sree Astha Laxmi',
                slug: 'shree-Astha-Laxmi-yantra',
                cod: true,
                online: true,
                photo: { 
                    image1: product1,
                    image2: productal13,
                    image3: product3,
                    image4: product4,
                    image5: product5,
                    // image6: product6,
                    image7: product7,
                    image8: product8,
                    // image9: productal11,
                },
                description: "Sree Ashta Laxmi brings together eight powerful forms of Goddess Lakshmi in one beautiful brass idol set. These eight manifestations are collectively known as the Ashta Lakshmi and are worshipped to gain blessings for holistic well-being and a balanced life.",
                metaTitle: "Shree Astha Laxmi Yantra Idol for Prosperity | SacredRelm",
                metaDescription: "SacredRelm Sree Astha Laxmi symbolizes eight forms of wealth and divine blessings. Ideal for home, office, or altar to invite prosperity, harmony, and blessings.",
                focusKeyword: "Shree Astha Laxmi Yantra",
                tags: ["sree astha laxmi", "ashta lakshmi yantra", "astha laxmi idol", "hindu goddess idol"],
                fullDescription:`
                    Experience the ultimate spiritual power and abundance with our Ashtalakshmi Pack, thoughtfully curated to bring wealth, protection, and divine energy into your life. This complete set beautifully combines sacred symbols and powerful tools associated with Goddess Lakshmi and Lord Kubera, making it perfect for your home, office, or sacred space.
                    ## What’s Included in the Ashtalakshmi Pack?
                    - {Kuber Kunji (Golden Key of Prosperity)}: This symbolic golden key is believed to unlock the doors to unlimited wealth and success. It acts as a spiritual tool to invite prosperity and remove obstacles in financial growth.
                    - {Gold Plated Chain}: A beautiful and durable gold-plated chain to wear your sacred pendants close to your heart, keeping divine blessings with you throughout the day.
                    - {Lakshmi Pendant (Sacred Goddess Medallion)}: This pendant features Goddess Lakshmi, the embodiment of wealth, fortune, and auspiciousness. Wearing this pendant invites her blessings and protection.    
                    - {Lakshmi Charan (Sacred Golden Footprints Plate)}: Symbolizing the arrival of Goddess Lakshmi into your home, this golden plate with holy prints invites fortune, happiness, and divine grace.
                    - {Meru Shri Yantram (3D Golden Pyramid)}: A three-dimensional pyramid yantra known for its ability to amplify positive energy, remove blockages, and create harmony in your surroundings.
                    `,
                // - {Kuber Dhan Varsha Yantra (Sacred Wealth Yantra)}: A powerful sacred geometric design that attracts abundance, prosperity, and financial stability. This yantra is energized with ancient mantras to enhance positive energy flow.
                // - {Meru Ring (Divine Energy Shield)}: Crafted as a spiritual shield, the Meru Ring balances energy and protects the wearer from negative influences while boosting spiritual power.
                whatsIncluded: [
                    {
                        name: "Kuber Kunji (Golden Key of Prosperity)",
                        description: "This symbolic golden key is believed to unlock the doors to unlimited wealth and success. It acts as a spiritual tool to invite prosperity and remove obstacles in financial growth."
                    },
                    {
                        name: "Kuber Dhan Varsha Yantra (Sacred Wealth Yantra)",
                        description: "A powerful sacred geometric design that attracts abundance, prosperity, and financial stability. This yantra is energized with ancient mantras to enhance positive energy flow."
                    },
                    {
                        name: "Gold Plated Chain",
                        description: "A beautiful and durable gold-plated chain to wear your sacred pendants close to your heart, keeping divine blessings with you throughout the day."
                    },
                    {
                        name: "Lakshmi Pendant (Sacred Goddess Medallion)",
                        description: "This pendant features Goddess Lakshmi, the embodiment of wealth, fortune, and auspiciousness. Wearing this pendant invites her blessings and protection."
                    },
                    {
                        name: "Meru Ring (Divine Energy Shield)",
                        description: "Crafted as a spiritual shield, the Meru Ring balances energy and protects the wearer from negative influences while boosting spiritual power."
                    },
                    {
                        name: "Lakshmi Charan (Sacred Golden Footprints Plate)",
                        description: "Symbolizing the arrival of Goddess Lakshmi into your home, this golden plate with her footprints invites fortune, happiness, and divine grace."
                    },
                    {
                        name: "Meru Shri Yantram (3D Golden Pyramid)",
                        description: "A three-dimensional pyramid yantra known for its ability to amplify positive energy, remove blockages, and create harmony in your surroundings."
                    }
                ],
                benefits: [
                    "Complete spiritual prosperity collection with seven sacred items",
                    "Invokes blessings of Goddess Lakshmi and Lord Kubera",
                    "Attracts wealth, abundance, and financial stability",
                    "Provides protection from negative influences",
                    "Amplifies positive energy and removes blockages",
                    "Promotes harmony and prosperity in all aspects of life",
                    "Perfect for home, office, or sacred space"
                ],
                faqs: [
                    {
                        question: "What items are included in the Ashta Lakshmi Pack?",
                        answer: "The pack includes Kuber Kunji (Golden Key of Prosperity), Kuber Dhan Varsha Yantra, Gold Plated Chain, Lakshmi Pendant, Meru Ring, Lakshmi Charan (Golden Footprints Plate), and Meru Shri Yantram (3D Golden Pyramid)."
                    },
                    {
                        question: "What is the purpose of the Kuber Kunji?",
                        answer: "The Kuber Kunji is a symbolic golden key believed to unlock financial prosperity and remove obstacles related to wealth."
                    },
                    {
                        question: "Can I wear the Lakshmi Pendant and Meru Ring daily?",
                        answer: "Yes, both the pendant and ring are designed to be worn daily to carry the divine blessings and protection with you."
                    },
                    {
                        question: "How do I use the Lakshmi Charan plate?",
                        answer: "Place the golden footprints plate at your home entrance or puja altar to invite Goddess Lakshmi's blessings and prosperity."
                    },
                    {
                        question: "What is the significance of the Meru Shri Yantram?",
                        answer: "The Meru Shri Yantram is a 3D pyramid yantra that helps amplify positive energy, remove negative blockages, and bring harmony to your space."
                    }
                ],
                reviews: [
                    { 
                        id: 1, 
                        user: 'Priya Sharma', 
                        rating: 5, 
                        comment: 'Since bringing this Astha Laxmi idol home, there has been a positive shift in our household finances. The craftsmanship is divine and the energy is palpable.', 
                        date: '2023-11-15' 
                    },
                    { 
                        id: 2, 
                        user: 'Rajesh Patel', 
                        rating: 4, 
                        comment: 'Beautiful detailing on this idol. The gold finish is exquisite and it has become the centerpiece of our home temple.', 
                        date: '2023-10-22' 
                    },
                    { 
                        id: 3, 
                        user: 'Anita Gupta', 
                        rating: 5, 
                        comment: 'Exceptional quality! This Laxmi idol radiates prosperity. Fast shipping and excellent packaging too.', 
                        date: '2023-09-18' 
                    },
                ]
            },
            {
                id: 7,
                category: 'Idols',
                cost: 1590,
                rating: 4.8,
                isNew: false,
                name: 'Sree Anjaneya Shani Raksha',
                slug: 'Shree-Anjaneya-Shani-Raksha-pack',
                cod: true,
                online: true,
                photo: {
                    image1: product20,
                    image2: product21,
                    image3: product23,
                    image4: product24,
                    image6: product26,
                    image7: product27,
                    image8: product28,
                    image9: product29,
                },
                description: "Sacredrelm Shree Anjaneya Shani Raksha brings together the powerful energies of Lord Hanuman and Lord Shani to protect you from negative forces, evil eye, and karmic difficulties. Hanuman Ji offers strength and fearlessness, while Lord Shani brings balance and justice. Together, they help you overcome hardships and stay aligned with positive energies.",
                metaTitle: "Shree Anjaneya Shani Raksha pack for Protection | SacredRelm",
                metaDescription: "SacredRelm Shree Anjaneya Shani Raksha protects from Shani dosha and negativity. Ideal for home or Offices to invoke strength, devotion, and spiritual protection.",
                focusKeyword: "Shree Anjaneya Shani Raksha pack",
                tags: ["Sree Anjaneya Shani Raksha", "Shani Raksha idol", "Sree Anjaneya Shani Raksha Yantram", "Shree anjaneya shani raksha pack"],
                fullDescription: `
                    The Shree Anjaneya Shani Raksha is a powerful spiritual tool combining the divine energies of Lord Hanuman and Lord Shani. This sacred item is specially designed to protect you from negative influences, obstacles, and the harmful effects of Shani Dosh .
                    
                    Lord Hanuman, known for his strength, courage, and devotion, acts as a fearless protector who removes fears, evil energies, and difficulties from your life. Lord Shani, the cosmic judge, governs karma and discipline, teaching patience and balance while helping to cleanse past karmas.
                    
                    Together, the energies of Anjaneya and Shani offer a unique shield that helps you navigate challenging phases in life, such as Shani Sade Sati or Shani Dhaiya, by reducing delays, hardships, and mental stress.

                `,
                benefits: [
                    "Provides strong protection against negative energies and evil influences",
                    // "Eases the impact of Saturn's challenging periods in astrology",
                    "Supports mental peace, spiritual growth, and emotional balance",
                    "Enhances your connection with divine energies for guidance and support",
                    "Boosts confidence, patience, and perseverance in difficult times",
                    "Safeguards from Shani Dosh and karmic difficulties"
                ],
                placement: [
                    "Place in your home temple or puja room for maximum spiritual benefits",
                    "Keep in meditation area or sacred space for divine protection",
                    "Ideal for office or workspace to overcome obstacles and challenges",
                    "Can be placed anywhere you need protection from negative influences"
                ],
                howToUse: [
                    "Keep it clean by gently wiping with a soft cloth",
                    "Avoid exposure to water or harsh chemicals to preserve its energy and appearance",
                    "Light a diya (lamp) and offer prayers regularly for enhanced blessings",
                    "Chant Hanuman Chalisa or Shani mantras for amplified protective energy"
                ],
                faqs: [
                    {
                        question: "What is Sree Anjaneya Shani Raksha?",
                        answer: "It is a sacred spiritual tool combining the energies of Lord Hanuman and Lord Shani to protect against negativity and reduce the effects of Shani Dosh."
                    },
                    {
                        question: "How does this product help?",
                        answer: "It provides protection from evil influences, reduces obstacles, eases karmic challenges related to Saturn, and strengthens courage and patience."
                    },
                    {
                        question: "Who should use the Anjaneya Shani Raksha?",
                        answer: "Anyone facing difficulties due to Shani's influence, such as Shani Sade Sati, or those seeking spiritual protection and mental peace can benefit."
                    },
                    {
                        question: "Where should I keep or place the Raksha?",
                        answer: "It is ideal to place it in your home temple, puja room, meditation area, or any sacred space."
                    },
                    {
                        question: "How do I care for the Raksha?",
                        answer: "Keep it clean by gently wiping with a soft cloth. Avoid exposure to water or harsh chemicals to preserve its energy and appearance."
                    }
                ],
                reviews: [
                    // {
                    // id: 1,
                    // user: "Subramanian Raju",
                    // rating: 5,
                    // date: "2023-08-12",
                    // comment: "I was going through Shani dasha period. My astrologer suggested this. After keeping in temple and doing Saturday pooja, problems are reducing. Very powerful!"
                    // },
                    {
                    id: 2,
                    user: "Vikram Singh",
                    rating: 5,
                    date: "2023-12-05",
                    comment: "The Anjaneya Shani Raksha idol brings immense peace and protection to our family. Truly divine energy!"
                    },
                    {
                    id: 3,
                    user: "Sunita Reddy",
                    rating: 4.5,
                    date: "2023-11-14",
                    comment: "Exquisite detailing and comes with useful accessories. Perfect addition to our pooja room."
                    },
                    {
                    id: 4,
                    user: "Rahul Verma",
                    rating: 5,
                    date: "2023-10-30",
                    comment: "Gifted this to my parents. They feel spiritually secure and blessed every day."
                    },
                    {
                    id: 5,
                    user: "Meera Joshi",
                    rating: 4,
                    date: "2023-09-25",
                    comment: "Excellent craftsmanship and protective packaging. The ritual guide was very helpful too."
                    }
                ]
            },
            {
                id: 8,
                category: 'Idols',
                cost: 1590,
                rating: 4.7,
                isNew: false,
                name: 'Sree Dhana Laxmi Akarsha Pack',
                slug: 'Shree-Dhana-Laxmi-Akarsha-Pack',
                cod: true,
                online: true,
                amazon: "https://www.amazon.in/dp/B0DY4J7VK6",
                photo: {
                    image1: product30,
                    image2: product31,
                    image3: product10,
                    image4: product11,
                    image5: product12,
                    image6: product13,
                    image7: product14,
                    image8: product15,
                    image9: product16,
                },
                description: "This pack centers around Dhana Lakshmi, one of the eight forms of Goddess Lakshmi associated with material wealth and financial growth. Each item in this pack works in harmony to amplify prosperity energies, remove financial blockages, and support your manifestations. Whether placed in your home, carried with you, or used in spiritual rituals, this pack serves as a powerful tool for attracting wealth and stability.",
                metaTitle: "SacredRelm | Shree Dhana Laxmi Akarsha Pack Wealth & Harmony",
                metaDescription: "Bring Blessings into your life with the Shree Dhana Laxmi Akarsha Pack. A powerful set to attract wealth, financial growth, harmony, and positive energy.",
                focusKeyword: "Shree Dhana Laxmi Akarsha Pack",
                tags: ["Dhana Laxmi akarsha pack", "Laxmi attract prosperity", "Laxmi blessings pack", "Shree Dhana Laxmi product", "Shree Dhana Lakshmi Akarsha Pack"],
                fullDescription: `                    
                    The Shree Dhana Laxmi Akarsha Pack is a sacred collection of spiritual items specially designed to invoke the blessings of Goddess Dhana Lakshmi, the divine form of Lakshmi who grants material wealth, financial growth, and abundance.

                    This powerful pack is ideal for those seeking prosperity, success in business, removal of financial obstacles, and a constant flow of wealth and good fortune in life. Each item in the set has been carefully chosen and spiritually energized to attract "Akarshan Shakti"  the divine magnetic energy that draws in opportunities, money, and prosperity.

                    Whether you're facing financial struggles, starting a new business, or simply wish to strengthen your connection with abundance, this pack serves as your spiritual companion on the path to wealth and stability.
                `,
                whatsIncluded: [
                    {
                        name: "Dhana Laxmi Yantra",
                        description: "A sacred geometrical diagram energized to attract wealth and remove financial blockages."
                    },
                    {
                        name: "Laxmi Coin",
                        description: "Symbolizes the continuous flow of wealth and divine grace."
                    },
                    {
                        name: "Laxmi Pendant or Idol",
                        description: "Represents the physical presence of Goddess Dhana Lakshmi for worship and protection."
                    },
                    {
                        name: "Gold-Plated Chain or Accessories",
                        description: "To wear and carry divine energy with you."
                    },
                    {
                        name: "Wealth-Attraction Mantra Card",
                        description: "Contains powerful mantras and instructions for daily chanting or meditation."
                    }
                ],
                benefits: [
                    "Attracts wealth, abundance, and financial stability",
                    "Removes money-related obstacles and blockages",
                    "Creates continuous flow of prosperity in life",
                    "Supports success in business and career",
                    "Amplifies prosperity energies through spiritually energized items",
                    "Strengthens connection with abundance and divine grace",
                    "Ideal for new business ventures and financial growth"
                ],
                howToUse: [
                    "Use during daily prayers or special occasions like Diwali, Fridays, or Akshaya Tritiya",
                    "Chant the provided mantra while focusing on your financial intentions",
                    "Place the yantra in your home temple, office, or sacred space",
                    "Wear the pendant and chain to carry divine energy with you",
                    "Keep the Laxmi coin in your wallet or cash box for continuous wealth flow"
                ],
                faqs: [
                    {
                        question: "What is the Shree Dhana Laxmi Akarsha Pack used for?",
                        answer: "This pack is designed to attract wealth, abundance, and financial stability by invoking the blessings of Goddess Dhana Lakshmi. It helps remove money-related obstacles and creates a flow of prosperity in your life."
                    },
                    {
                        question: "Who should use this pack?",
                        answer: "Anyone looking for financial growth, success in business or career, or relief from money struggles can benefit. It is also ideal for business owners, entrepreneurs, or anyone starting a new venture."
                    },
                    {
                        question: "What does the pack contain?",
                        answer: "The pack typically includes a Dhana Laxmi Yantra, a Laxmi coin, a sacred pendant or idol, a gold-plated chain, and mantra/instruction card. Each item is spiritually energized for maximum benefit."
                    },
                    {
                        question: "How should I use the pack?",
                        answer: "You can use it during daily prayers or special occasions like Diwali, Fridays, or Akshaya Tritiya. Chant the provided mantra while focusing on your financial intentions to strengthen the energy."
                    },
                    {
                        question: "Will it work instantly?",
                        answer: "Like all spiritual tools, results depend on your faith, consistency, and karma. Use the pack with devotion and positive intention for best results over time."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Vimala Krishnan",
                    rating: 5,
                    date: "2024-09-15",
                    comment: "Complete pack with all items! We started using from Dhanteras day. Money flow is improving in our household. Lakshmi Devi's blessings are there!"
                    },
                    {
                    id: 2,
                    user: "Ramakrishna Sastry",
                    rating: 4.7,
                    date: "2024-08-22",
                    comment: "My daughter's marriage expenses were worrying me. After using this Dhana Laxmi pack and doing Friday poojas, unexpected money sources came. Very grateful!"
                    },
                    {
                    id: 3,
                    user: "Neha Desai",
                    rating: 5,
                    date: "2024-12-10",
                    comment: "Ever since I started using the Dhana Laxmi Akarsha Pack, my financial worries have eased. The yantra and idol are both beautifully crafted."
                    },
                    {
                    id: 4,
                    user: "Prakash Iyer",
                    rating: 4.5,
                    date: "2024-11-02",
                    comment: "Very effective and thoughtfully packed. The ritual guide was very helpful for my family."
                    },
                    {
                    id: 5,
                    user: "Sneha Rathi",
                    rating: 4.5,
                    date: "2024-10-19",
                    comment: "A must-have for anyone wanting to attract good luck and financial stability. Highly recommend!"
                    }
                ]
            },
            {
                id: 9,
                category: 'Yantras',
                cost: 1490, // Please update with actual price
                rating: 4.7,
                isNew: false,
                name: 'Shree Yantra Wall Hanging – Get Kuber Key & Tortoise Pendant Free',
                slug: 'Shree-Yantra-Wall-Hanging-with-Kuber-Key-Tortoise',
                cod: true,
                online: true,
                photo: {
                    image1: product52,
                    image2: product84,
                    image3: product96
                },
                description: "The Shree Yantra Wall Hanging is a powerful symbol of prosperity and spiritual harmony for your home or office. It comes with a free Kuber Key, believed to attract wealth and financial abundance, and a Tortoise Pendant that symbolizes protection, longevity, and positive energy. This sacred combination invites success, peace, and good fortune into your life, creating a positive and harmonious environment.",
                metaTitle: "Shree Yantra Wall Hanging with Free Kuber Key & Tortoise",
                metaDescription: "Shree Yantra wall hanging brings prosperity & positive energy. Comes with a free Kuber key and tortoise pendant to attract wealth, luck, and Harmony.",
                focusKeyword: "Shree Yantra Wall Hanging with Kuber Key & Tortoise",
                tags: ["Shree Yantra wall hanging", "Kuber key pendant", "spiritual wall hanging", "free tortoise gift"],
                fullDescription: `
                    The Shree Yantra is one of the most powerful and ancient symbols in Vastu Shastra and Hindu spirituality. It is a sacred geometric design representing the divine energy of Goddess Lakshmi, the goddess of wealth, prosperity, and abundance. Shree Yantra has been used for thousands of years by sages, kings, and traders to attract success, financial growth, and positive energy.
                    This particular Yantra is crafted on a Raw Pyrite Frame, which is known as “Fool’s Gold.” Pyrite is believed to amplify energy, attract wealth, and protect against negative vibrations. Combining Shree Yantra with Pyrite makes it a potent Vyapar Vriddhi Yantra, designed specifically to enhance business growth and overall prosperity.
                `,
                freeAccessories: [
                    {
                        name: "Kuber Key",
                        image: product68, // Update with actual image
                        description: "Kuber is the Hindu deity of wealth. The Kuber Key is believed to unlock financial opportunities, attract money, and maintain stability in business and personal finances."
                    },
                    {
                        name: "Tortoise Pendant",
                        image: product91, // Update with actual image
                        description: "In Vastu and Feng Shui, the tortoise symbolizes longevity, protection, and support. Placing it with the Shree Yantra helps safeguard wealth, health, and family well-being."
                    }
                ],
                benefits: [
                    "Financial Growth: Attracts money, business opportunities, and stability",
                    "Positive Energy: Clears negative vibes and brings peace and harmony into spaces",
                    "Protection: Guards against losses, obstacles, and negativity in life and business",
                    "Spiritual Upliftment: Helps in meditation, concentration, and connecting with divine energy",
                    "Business Prosperity: Ideal for shops, offices, and business owners looking to increase profits",
                    "Overall Well-being: Brings peace, happiness, and good fortune to family and surroundings"
                ],
                howToUse: [
                    "Hang the Yantra facing east or north in your home, office, or shop",
                    "Keep it at a height above eye level for maximum energy flow",
                    "Regularly clean and dust the Yantra to maintain its energy",
                    "Chant the mantra 'Om Shreem Hreem Shreem Mahalakshmiyei Namah' while focusing on the Yantra to boost its effects",
                    "Can be used in both personal and professional spaces for maximum benefits"
                ],
                placement: [
                    "Hang facing east or north in your home, office, or shop",
                    "Position at a height above eye level for optimal energy flow",
                    "Ideal for living rooms, offices, shops, or business premises",
                    "Works best in spaces where financial activities or decision-making occur"
                ],
                faqs: [
                    {
                        question: "Can I give it to someone?",
                        answer: "Yes, it is a perfect gift for friends, family, or business partners to wish them success and prosperity."
                    },
                    {
                        question: "Does it work for small businesses?",
                        answer: "Yes, even small business owners can benefit from the positive energy and financial growth it brings."
                    },
                    {
                        question: "Is it only for business growth?",
                        answer: "No, it also helps in personal life, relationships, health, and overall positive energy."
                    },
                    {
                        question: "Can I use it in my car or vehicle?",
                        answer: "Yes, but it works best in homes, offices, or shops."
                    },
                    {
                        question: "Is it suitable for all religions?",
                        answer: "Yes, it works on energy and positivity principles, so anyone can use it."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Kamakshi Venkataraman",
                    rating: 4.8,
                    date: "2024-12-20",
                    comment: "Hanged this Shree Yantra in our shop entrance. Kuber Key and tortoise pendant also we keep in cash box. Sales are increasing every month!"
                    },
                    {
                    id: 2,
                    user: "Narayanan Pillai",
                    rating: 5,
                    date: "2024-11-18",
                    comment: "Very powerful combination! Shree Yantra with pyrite is looking very beautiful. Business opportunities are coming automatically. Highly recommend!"
                    },
                    {
                    id: 3,
                    user: "Pushpa Ramamoorthy",
                    rating: 4.7,
                    date: "2024-10-25",
                    comment: "Bought for my son's new office. He placed in north direction. Within 2 months, his company got big contract. Free gifts are also useful. Excellent value!"
                    },
                    {
                    id: 4,
                    user: "Balaji Srinivasan",
                    rating: 5,
                    date: "2024-09-12",
                    comment: "This wall hanging is blessing our home! I worship every Friday with kumkum and flowers. Family prosperity and harmony increased a lot. Thank you!"
                    },
                    {
                    id: 5,
                    user: "Ramesh Kumar",
                    rating: 5,
                    date: "2025-01-15",
                    comment: "Amazing product! The free accessories are a great bonus. My business has seen steady growth since hanging this."
                    }
                ]
            },
            {
                id: 11,
                category: 'Yantras',
                cost: 890,
                rating: 4.7,
                isNew: false,
                name: 'Sree Anjaneya\'s Gada',
                slug: 'Shree-anjaneya-Gada',
                cod: true,
                online: true,
                photo: {
                    image1: product48,
                    image2: product70
                },
                description: "Shree Anjaneya's/ Hanuman Gada shows Lord Hanuman's strength and protection. It represents courage, power, and victory. You can keep it in home temples, on office desks, or gift it to loved ones. It brings blessings, bravery, and success to everyone.",
                metaTitle: "Shree Anjaneya's Gada Symbol of Strength & Faith | SacredRelm",
                metaDescription: "Shree Anjaneya's Gada represents Hanuman's unwavering devotion and power. A perfect addition to your spiritual space and the resolve to overcome fear.",
                focusKeyword: "Shree Anjaneya/Hanuman Gada",
                tags: ["Shree Anjaneya's/Hanuman Gada", "lord hanuman spiritual item", "hanuman mace idol", "gada of lord hanuman"],
                fullDescription: `
                    The Gada of Lord Hanuman, also called Anjaneya, is a powerful symbol of strength, courage, and protection. The Gada is a reminder of his ability to remove obstacles and protect devotees. Many people keep it to feel safe, brave, and inspired every day.
                    ##Craftsmanship and Material

                    This Gada is made with strong and durable materials. It is carefully designed to show Lord Hanuman’s weapon in detail. Its beautiful finish makes it perfect for home temples, offices, or as a gift.
                    ##How to Use
                    - Keep it in a clean place, higher than eye level, like a home temple or desk.
                    - Offer prayers to Lord Hanuman while keeping the Gada nearby.
                    - editate or focus on it to feel strength, courage, and protection.
                    ##Why It’s Special
                    The Shree Anjaneya’s Gada is not just a decorative item. It is a tool that gives courage, protection, and positive energy. It reminds you to be strong, brave, and devoted in daily life.
                `,
                benefits: [
                    "Strength and Courage: The Gada reminds you to be brave and face challenges without fear",
                    "Protection: Believed to protect homes and offices from negative energy and problems",
                    "Victory and Success: Shows the power to win over difficulties and encourages confidence and determination",
                    "Devotion and Faith: Helps you feel more devoted and connected to Lord Hanuman",
                    "Positive Energy: Brings peace, protection, strength, and success to your space"
                ],
                placement: [
                    "Place it in home temples to feel spiritual energy",
                    "Keep it on office desks to feel brave and confident",
                    "Position it in a clean place, higher than eye level",
                    "Use it as a decoration that also gives inspiration and positivity"
                ],
                howToUse: [
                    "Keep it in a clean place, higher than eye level, like a home temple or desk",
                    "Offer prayers to Lord Hanuman while keeping the Gada nearby",
                    "Meditate or focus on it to feel strength, courage, and protection",
                    "Gift it to family and friends for blessings and protection",
                    "Regularly clean and maintain it with respect to preserve its energy"
                ],
                faqs: [
                    {
                        question: "Who is Lord Hanuman?",
                        answer: "Hanuman is a Hindu god known for his power, bravery, and devotion to Lord Rama."
                    },
                    {
                        question: "Why should I keep this Anjaneya/Hanuman Gada?",
                        answer: "It inspires courage, confidence, and protects your home from negative energy."
                    },
                    {
                        question: "Can I gift it to someone?",
                        answer: "Absolutely, it is a great gift for family, friends, or colleagues."
                    },
                    {
                        question: "Does it bring overall positive energy?",
                        answer: "Yes, it brings peace, protection, strength, and success to anyone who keeps it."
                    },
                    {
                        question: "Will it make my home happier?",
                        answer: "Yes, it brings peace, positivity, and good vibes to the house."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Kamakshi Venkataraman",
                    rating: 4.8,
                    date: "2024-12-20",
                    comment: "Hanged this Shree Yantra in our shop entrance. Kuber Key and tortoise pendant also we keep in cash box. Sales are increasing every month!"
                    },
                    {
                    id: 2,
                    user: "Narayanan Pillai",
                    rating: 5,
                    date: "2024-11-18",
                    comment: "Very powerful combination! Shree Yantra with pyrite is looking very beautiful. Business opportunities are coming automatically. Highly recommend!"
                    },
                    {
                    id: 3,
                    user: "Pushpa Ramamoorthy",
                    rating: 4.7,
                    date: "2024-10-25",
                    comment: "Bought for my son's new office. He placed in north direction. Within 2 months, his company got big contract. Free gifts are also useful. Excellent value!"
                    },
                    {
                    id: 4,
                    user: "Balaji Srinivasan",
                    rating: 5,
                    date: "2024-09-12",
                    comment: "This wall hanging is blessing our home! I worship every Friday with kumkum and flowers. Family prosperity and harmony increased a lot. Thank you!"
                    },
                    {
                    id: 5,
                    user: "Ramesh Kumar",
                    rating: 5,
                    date: "2025-01-15",
                    comment: "Amazing product! The free accessories are a great bonus. My business has seen steady growth since hanging this."
                    }
                ]
            },
            {
                id: 12,
                category: 'Yantras',
                cost: 890,
                rating: 4.7,
                isNew: false,
                name: 'Shri Hanuman Chalisa Yantra Locket – Get Gold Plated Chain Free',
                slug: 'Shree-Hanuman-Chalisa-Yantra-Locket',
                cod: true,
                online: true,
                photo: {
                    image1: product50,
                    image2: product67,
                    image3: product89
                },
                description: "Shree Hanuman Chalisa Yantra Locket brings the divine power of Lord Hanuman close to you. This sacred locket, engraved with the complete Hanuman Chalisa, protects you from fear, negativity, and evil energies. It fills your life with courage, confidence, and spiritual strength. Comes with a free gold-plated chain - an ideal gift for yourself or your loved ones.",
                metaTitle: "Shree Hanuman Chalisa Yantra Locket with free gold plated chain",
                metaDescription: "Wear the power of faith with this Hanuman Chalisa Yantra locket. Includes full Chalisa inside & get free gold chain. A shield of strength and protection.",
                focusKeyword: "Shree Hanuman Chalisa Yantra Locket",
                tags: ["Hanuman Chalisa Yantra locket", "Shri Hanuman Chalisa pendant", "Yantra locket with chain"],
                fullDescription: `
                    The Shree Hanuman Chalisa Yantra Locket is a sacred pendant that carries the blessings of Lord Hanuman, the symbol of strength, devotion, and protection. This holy locket contains the entire Hanuman Chalisa written using special micro-technology and is designed to keep divine energy close to your heart. It is believed to remove fear, protect from negativity, and fill your life with courage, confidence, and spiritual strength. Each locket comes with a free gold-plated chain, making it a perfect blend of devotion and beauty.
                    ##History of Hanuman Chalisa Yantra
                    The Hanuman Chalisa was written by Saint Tulsidas in the 16th century in praise of Lord Hanuman, who is known for his loyalty to Lord Rama and his unmatched power. “Chalisa” means forty verses, and each verse praises Lord Hanuman’s courage, devotion, and divine strength. For centuries, devotees have recited the Hanuman Chalisa to remove obstacles, overcome fear, and invite divine blessings. The Yantra locket version makes it easy for devotees to carry the power of the Hanuman Chalisa wherever they go.
                    ##What is it made of?
                    - Hanuman Chalisa Yantra: A miniature inscription of the complete Hanuman Chalisa created using advanced nano-print technology.
                    - Gold-Plated Locket: Shiny, durable, and elegant metal finish that protects the sacred content inside.
                    - Free Gold-Plated Chain: Included for convenience and daily wear.

                
                `,
                freeAccessories: [
                    { 
                        name: "Gold Plated Chain", 
                        image: product71, 
                        description: "Beautiful and durable gold-plated chain included for convenient daily wear."
                    }
                ],
                benefits: [
                    "Protection from Negativity: Shields you from evil eyes, black magic, and negative vibrations",
                    "Brings Courage and Strength: Fills your mind and body with confidence and inner power",
                    "Spiritual Growth: Keeps you close to divine energy and reminds you of faith in Lord Hanuman",
                    "Removes Obstacles: Helps clear challenges in your personal and professional life",
                    "Peace of Mind: Promotes calmness, focus, and emotional stability",
                    "Perfect Gift: Ideal for gifting on religious occasions, Hanuman Jayanti, or to someone starting a new journey"
                ],
                howToUse: [
                    "Wear Daily: Keep it close to your heart to stay connected with divine energy",
                    "Morning Ritual: Before wearing, chant 'Om Hanumate Namah' or recite the Hanuman Chalisa",
                    "Placement (if not worn): You can also keep it in your pooja room, car, or wallet for protection",
                    "Respectful Handling: Keep the locket clean and avoid placing it in impure places",
                    "Faith & Devotion: Believe in Lord Hanuman's energy and wear it with pure intentions"
                ],
                faqs: [
                    {
                        question: "What is the purpose of the Hanuman Chalisa Yantra Locket?",
                        answer: "It protects the wearer from negative energies, boosts confidence, and invites divine blessings."
                    },
                    {
                        question: "Does it come with a chain?",
                        answer: "Yes, a free gold-plated chain is included with every locket."
                    },
                    {
                        question: "Can it protect from evil eye or black magic?",
                        answer: "Yes, it is believed to safeguard the wearer from negative energies and evil influences."
                    },
                    {
                        question: "Can I gift it to someone?",
                        answer: "Yes, it's a meaningful spiritual gift suitable for all occasions."
                    },
                    {
                        question: "Can I place it in my pooja mandir instead of wearing it?",
                        answer: "Yes, it can be kept in your home temple for blessings and peace."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Shyamala Subramaniam",
                    rating: 5,
                    date: "2024-09-22",
                    comment: "Complete Hanuman Chalisa in small locket is wonderful! I wear daily for protection. Evil eye and negative people cannot affect me now. Very blessed!"
                    },
                    {
                    id: 2,
                    user: "Parthasarathy Iyer",
                    rating: 4.7,
                    date: "2024-08-15",
                    comment: "Bought for my wife and children. All three are wearing. Since then, family problems reduced. Hanuman ji is protecting us. Chain quality also good!"
                    },
                    {
                    id: 3,
                    user: "Neha Desai",
                    rating: 5,
                    date: "2024-12-10",
                    comment: "I feel so much more protected and confident wearing this Shri Hanuman Chalisa Yantra Locket every day."
                    },
                    {
                    id: 4,
                    user: "Prakash Iyer",
                    rating: 4.5,
                    date: "2024-11-02",
                    comment: "Beautiful locket with powerful energy. It gives me mental strength and wards off negativity."
                    },
                    {
                    id: 5,
                    user: "Sneha Rathi",
                    rating: 4.5,
                    date: "2024-10-19",
                    comment: "Very effective for daily wear and prayers. I gifted it to my brother and he loves it."
                    }
                ]
            },
            {
                id: 13,
                category: 'Yantras',
                cost: 890,
                rating: 4.7,
                isNew: false,
                name: 'Sree Astha Lakshmi devi locket – Get Shri Dhan Laxmi Yantra Locket Free',
                slug: 'sree-astha-lakshmi-devi-locket-get-shri-dhan-laxmi-yantra-locket-free',
                cod: true,
                online: true,
                photo: {
                    image1: product42,
                    image2: product76
                },
                description: "Shree Ashta Lakshmi Devi Locket brings the divine blessings of Goddess Lakshmi in her eight powerful forms. This sacred locket helps attract wealth, prosperity, good health, and happiness into your life. It is beautifully designed to protect you from negativity and fill your home with positive energy and peace. With this locket, you also receive a free Shri Dhan Laxmi Yantra Locket, which helps in bringing good fortune and financial growth.",
                metaTitle: "Buy Shree Ashta Lakshmi Devi Locket - Get Free Dhan Lakshmi Yantra",
                metaDescription: "Wear blessings of all eight Lakshmi's with Shree Ashta Lakshmi Devi locket, and get with a free Dhan Lakshmi Yantra locket to enhance wealth, balance and Harmony.",
                focusKeyword: "Shree Ashta Lakshmi Devi locket",
                tags: ["Shree Ashta Lakshmi Devi locket", "Dhan Lakshmi Yantra locket free", "Hindu goddess locket"],
                fullDescription: `
                    The Sree Ashta Lakshmi Devi Locket is a sacred and powerful charm that carries the blessings of Goddess Lakshmi in her eight divine forms, known as Ashta Lakshmi. Each form represents a different kind of wealth and happiness. such as money, success, courage, knowledge, food, fertility, and victory.
                    Wearing or keeping this locket is believed to bring prosperity, peace, and protection into your life. It helps remove financial struggles and attracts positive energy, making it a perfect symbol of good fortune and abundance.
                    This locket also comes with a free Shri Dhan Laxmi Yantra Locket, which enhances your wealth vibrations and keeps you surrounded by divine blessings.
                    ##History and Meaning
                    The concept of {Ashta Lakshmi} comes from ancient Hindu scriptures, where Goddess Lakshmi is worshipped not only as the goddess of wealth but also as the giver of all kinds of prosperity.
                    The eight forms of Lakshmi are:
                    {Aadi Lakshmi} - for eternal wealth and peace.


                    {Dhana Lakshmi} - for financial prosperity.


                    {Dhanya Lakshmi} - for food, health, and nourishment.


                    {Gaja Lakshmi} - for power and success.


                    {Santana Lakshmi} - for fertility, family, and children.


                    {Veera Lakshmi} - for courage and strength.


                    {Vijaya Lakshmi} - for victory in all aspects of life.


                    {Vidya Lakshmi} - for wisdom, learning, and knowledge.


                    Together, these eight forms bless every area of life - spiritual, material, emotional, and physical well-being.

                
                `,
                freeAccessories: [
                    { 
                        name: "Shri Dhan Laxmi Yantra Locket", 
                        image: product75, 
                        description: "Sacred geometric charm that works like a money magnet, supporting financial growth and luck."
                    }
                ],
                benefits: [
                    "Attracts wealth, prosperity, and financial stability",
                    "Brings peace, harmony, and happiness into your home",
                    "Helps you gain success in business, job, and studies",
                    "Removes obstacles and negative energies from life",
                    "Strengthens your spiritual connection with Goddess Lakshmi",
                    "Promotes good health and positive energy around you",
                    "Encourages growth, fortune, and family well-being",
                    "Works as a lucky charm for abundance and progress"
                ],
                howToUse: [
                    "Wear it daily for continuous blessings and protection",
                    "Keep it in your wallet, cash box, or locker to attract financial growth",
                    "Place it in your home temple or pooja room for peace and divine energy",
                    "Gift it to loved ones as a token of good luck and prosperity",
                    "If not wearing, keep it in a clean place facing east or north"
                ],
                placement: [
                    "Wear daily around your neck for continuous divine blessings",
                    "Keep in wallet or cash box for attracting financial growth",
                    "Place in home temple or pooja room facing east or north",
                    "Can be kept near your pillow or pooja place at night if preferred"
                ],
                faqs: [
                    {
                        question: "What does Ashta Lakshmi mean?",
                        answer: "Ashta Lakshmi means 'Eight Lakshmis' - the eight aspects of Goddess Lakshmi that bless different parts of life like wealth, food, courage, and wisdom."
                    },
                    {
                        question: "Can I wear it while sleeping?",
                        answer: "Yes, it's safe to wear, but some people prefer keeping it near their pillow or pooja place at night."
                    },
                    {
                        question: "Where should I keep it if not wearing it?",
                        answer: "Keep it in your pooja room, cash box, or in a clean place facing east or north."
                    },
                    {
                        question: "What is the free Shri Dhan Laxmi Yantra Locket?",
                        answer: "It's a sacred geometric charm that works like a money magnet, supporting financial growth and luck."
                    },
                    {
                        question: "Can I gift this locket to someone?",
                        answer: "Yes, it's a wonderful spiritual gift for family, friends, or business associates."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Vasantha Ramachandran",
                    rating: 5,
                    date: "2024-09-14",
                    comment: "Two lockets in one purchase is very good! Ashta Lakshmi blessings are coming. My job promotion came after wearing this. Very happy with product!"
                    },
                    {
                    id: 2,
                    user: "Seetharaman Venkatesh",
                    rating: 4.8,
                    date: "2024-08-20",
                    comment: "Gifted to my wife on her birthday. She wears both lockets alternately. Our household income improved. Unexpected money also came. Lakshmi ji's grace!"
                    },
                    {
                    id: 3,
                    user: "Neha Desai",
                    rating: 5,
                    date: "2024-12-10",
                    comment: "I have been wearing this locket for a few weeks now and have experienced unexpected financial gains and stability."
                    },
                    {
                    id: 4,
                    user: "Prakash Iyer",
                    rating: 4.5,
                    date: "2024-11-02",
                    comment: "Highly recommended for anyone looking to attract wealth energy. It's lightweight, well-crafted, and feels powerful."
                    },
                    {
                    id: 5,
                    user: "Sneha Rathi",
                    rating: 4.5,
                    date: "2024-10-19",
                    comment: "Blessed locket with great positive vibrations. I feel more confident and secure about my finances."
                    }
                ]
            },
            {
                id: 14,
                category: 'Yantras',
                cost: 890,
                rating: 4.7,
                isNew: false,
                name: 'Meru Sriyantram – Get Gurrapu Nada Free',
                slug: 'Meru-ring-Yantram-Tortoise',
                cod: true,
                online: true,
                photo: {
                    image1: product47,
                    image2: product72,
                },
                description: "Meru Sriyantra Tortoise brings wealth, peace, and good energy to your home or office. It combines the power of the 3D Sri Yantra with the luck and stability of the tortoise. Place it in your living room, office, or pooja room to protect finances and promote harmony. Special Offer: Get a Gurrapu Nada free with your purchase.",
                metaTitle: "Buy Meru Sri Yantram Tortoise & Get Free Gurrapu Nada | SacredRelm",
                metaDescription: "Meru Sri Yantram Tortoise is a sacred tool for wealth, harmony, and spiritual balance. Paired with a free Gurrapu Nada, perfect for Vastu, rituals, and meditation.",
                focusKeyword: "Meru ring Yantram Tortoise",
                tags: ["Meru Sri Yantram", "gurrapu nada free", "Yantram with free Gurrapu Nada", "yantra for prosperity"],
                fullDescription: `
                    Meru Sriyantra Tortoise is a sacred Vastu tool that combines the 3D Meru Sri Yantra with the tortoise, a symbol of stability, longevity, and good fortune. This sacred combination is believed to bring wealth, positive energy, protection, and harmony to homes and offices.

                    ##History of Sri Yantra and Tortoise
                    - The Sri Yantra is one of the oldest and most powerful geometric symbols in Hinduism, representing the divine energy of Goddess Lakshmi, the goddess of wealth and prosperity.
                    - The Meru Sri Yantra is a three-dimensional form of the Sri Yantra, amplifying its spiritual and energetic powers.
                    - The tortoise (Kurma) is an ancient symbol in Vastu Shastra and Hindu mythology, representing stability, support, and long-lasting prosperity.
                    - Combining the Sri Yantra with the tortoise creates a tool believed to balance energies, attract wealth, and protect against negativity.
                    ##Special Offer
                    With every purchase, you get a {Gurrapu Nada free}, a sacred instrument that further enhances the positive energy in your space.
                
                `,
                freeAccessories: [
                    { 
                        name: "Gurrapu Nada", 
                        image: product72, 
                        description: "Sacred bell that purifies surroundings, boosts positive energy, and enhances spiritual vibrations in your space."
                    }
                ],
                benefits: [
                    "Attracts Wealth and Prosperity: Enhances financial growth and business success",
                    "Positive Energy: Removes negative vibrations from your home or office",
                    "Harmony and Peace: Promotes balance, reducing stress and conflict",
                    "Protection: Guards finances and home from misfortune",
                    "Spiritual Growth: Helps in meditation and enhances mental clarity",
                    "Longevity and Stability: Tortoise symbolizes long life and steady progress"
                ],
                faqs: [
                    {
                        question: "Why is it called Meru Sriyantra?",
                        answer: "Because the Sri Yantra is in a 3D pyramid shape called 'Meru,' which is believed to boost its energy."
                    },
                    {
                        question: "Does it really bring wealth?",
                        answer: "Yes, many people feel more financial stability and positive energy when placed correctly."
                    },
                    {
                        question: "What is Gurrapu Nada?",
                        answer: "A sacred bell that purifies surroundings and boosts energy."
                    },
                    {
                        question: "Does it need to be energized regularly?",
                        answer: "Optional, but chanting mantras or performing pooja occasionally helps."
                    },
                    {
                        question: "Can I place multiple yantras together?",
                        answer: "Yes, but each should have its own space and not block energy flow."
                    }
                ],
                reviews: [
                    {
                    id: 1,
                    user: "Padma Narasimhan",
                    rating: 5,
                    date: "2025-02-18",
                    comment: "Meru Yantra with tortoise base is very auspicious combination! We keep in northeast corner. Free Gurrapu Nada bell also nice quality. Home atmosphere is peaceful!"
                    },
                    {
                    id: 2,
                    user: "Govindarajan Pillai",
                    rating: 4.8,
                    date: "2025-01-22",
                    comment: "My office Vastu was not proper. After placing this Meru Sriyantram facing east, positive changes started happening. Business growth is steady now!"
                    },
                    {
                    id: 3,
                    user: "Kavitha Reddy",
                    rating: 5,
                    date: "2025-05-15",
                    comment: "This Meru Sriyantra Tortoise has brought a calming vibe to my home. I can genuinely feel a positive shift in finances and relationships since placing it in our living room."
                    },
                    {
                    id: 4,
                    user: "Ramesh Joshi",
                    rating: 4.8,
                    date: "2025-04-27",
                    comment: "Excellent product with fine detailing. I keep it near my work desk and it gives a sense of balance and stability. Highly recommend for anyone believing in Vastu."
                    },
                    {
                    id: 5,
                    user: "Anjali Mehta",
                    rating: 4.7,
                    date: "2025-03-30",
                    comment: "Beautifully crafted and well-packed. I use it for daily prayers and have noticed more harmony at home. Great buy for its price."
                    }
                ]
            },                               
        ],
    },
    blogs: [
        {
            id: 1,
            title: "Sacredrelm: Religious & Spiritual Product Karungali Mala",
            slug: "karungali-mala",
            date: "October 17, 2025",
            excerpt:
            "There are certain holy items that are deeply related to divine energies and hold a profound history. One such energetic and sacred object is the Karungali Mala.",
            // If you have an image asset uncomment above import and set this key:
            image: blog1,
            readTime: "6 min read",
            focusKeyword: "Karungali Mala",
            metaDescription:
            "Sacredrelm Karungali Mala, crafted from holy ebony wood, connects you to divine strength, shields you from negativity, and deepens your spiritual journey.",
            tags: ["Karungali Mala", "Ebony mala", "Vedic spirituality", "Root chakra", "Mars Mangal remedy", "Mantra japa"],
            content: `## Sacredrelm: Religious & Spiritual Product Karungali Mala

                (para align) There are certain holy items that are deeply related to divine energies and hold a profound history. One such energetic and sacred object is the [Karungali Mala]. With its healing potential to protect, purify, and empower, it has become extremely popular in the last few days.

                It has been worn by saints, yogis, and pilgrims for centuries as a doorway between the material and spiritual worlds.

                ## What is Karungali Mala?

                (para align) Karungali Mala is a beaded necklace that has been crafted using the wood of the ebony tree. The ebony tree is reputed to have strong spiritual energy in Hindu and predominantly Tamil contexts.

                The name Karungali is derived from the Tamil "Karuppu" (black) and "Kali" (wood). This indicates the dark, black wood of ebony that is utilized to create the mala. This wood is sacred in Vedic cultures and holds a significant place in religion and spirituality.

                It will have 108 beads and one guru bead, symbolizing the universe, completeness of God, and the cycle of life. It is not just a necklace; it represents divine protection.

                ## Spiritual Significance of Karungali Mala
                (para align) The significance of Karungali Mala is from ancient philosophies. The Vedas have written about the mala, speaking about how it can help cleanse negative energies, purify the aura, and create protection around the person who uses it.  The following are a few of the most significant spiritual benefits associated with it.

                ### 1. Shield Against Negative Energy
                The main well-known advantage of the mala is the protection it gives against negative energies and protects the person from any negative influence. It is said to cancel out negative vibrations, ward off evil eyes, and protect from negative energies. This one advantage has made the mala so popular in recent days for those seeking an amplified, purer aura.

                ### 2.Balancing Earth Energy
                A balanced [root chakra] can result in greater confidence and a more solid, peaceful attitude towards life. The mala uses ebony wood, which is strongly connected with the earth element or the root chakra. This will help grounding the vibration and stabilize the energy around the individual, which will strengthen the root chakra.

                ### 3.Associated with Mars (Mangal):
                it is said that to calm the influence of the planet [Mars (Mangal)], karungali mala is used. Mars is the ruler of energy, aggression, courage, and bodily strength. The mala transforms impulsiveness into channeled strength, discipline, and brave action. For this reason, it is extremely useful for leaders and entrepreneurs, and anybody wishing to transcend adversities.

                ### 4. Encourages Inner Peace and Clarity
                The soothing vibrations of the mala are said to calm stress and anxiety. For those whose minds are usually restless, karungali mala imparts a sense of calmness, enhances mental clarity, and helps with sound decision-making.

                ### 5. Drawing Prosperity and Strength
                Along with protection and peace, numerous devotees think that the mala facilitates the drawing of positive fortune, prosperity, and success. Additionally, it is found to be related to strength and courage within one's soul, enabling the wearer to face tough challenges with strength.

                ## Religious Usage and Rituals
                In the Hindu religion, it occupies a revered position in rituals and practices. It is used as:
                ### 1.Mantra Japa
                Chanting sacred mantras of Shiva or Shakti with the beads increases the mantra's potency.
                ### 2.Meditation
                Wearing or holding the mala during meditation soothes the mind and brings you into tune with higher consciousness.
                ### 3.Temple Worship
                Numerous devotees present it to deities as an act of devotion and appreciation.
                To get the maximum energy out of it, energize the Karungali Mala prior to first use by placing it in front of a deity, lighting a diya, and repeating a short prayer.

                ## How to Maintain Your Karungali Mala?
                1. Energize it regularly by exposing it to sunlight or incense.
                2. Avoid water and chemicals to preserve the purity of the wood.
                3. Wear it mindfully, don't let other individuals touch or wear your mala.
                4. Wear it like a neck mala or wrist band daily, so its protective energy is close to your heart and aura.

                ## Why Every Spiritual Seeker Needs a Karungali Mala?
                A Dedicated practitioner or a newcomer to meditation, or just looking for balance in your life, this is a profound life life-changing one. In this busy world full of distraction and negativity present in the world, the Karungali Mala acts as a call to remain grounded, aware, and connected to the divine.
                Honor the strength of Karungali Mala and welcome blessings, equilibrium, and sacred fortune into your life.

                ## Conclusion:
                The Karungali Mala is more than just a spiritual ornament. It is a symbol of divine protection, inner power, and spiritual awakening. The Karungali Mala helps clean your energy, keep you calm, and bring peace to your mind. In today’s busy life, it reminds you to stay steady and close to the divine. If you want to feel its power, buy your Karungali Mala from Sacredrelm and bring peace and positivity into your life.
            `
        }
    ]

};

export default translations;



// {
            //     id: 15,
            //     category: 'Yantras',
            //     cost: 990,
            //     rating: 4.7,
            //     isNew: true,
            //     name: 'Shree Yantra Energy Pyramid',
            //     slug: 'shree-yantra-energy-pyramid',
            //     cod: true,
            //     online: true,
            //     photo: {
            //         image1: product78,
            //         image2: product61,
            //     },
            //     description: "The Shree Yantra Energy Pyramid is a powerful spiritual tool designed to harmonize your environment and attract positive energy. Crafted with precision, this pyramid features the sacred Shree Yantra, a revered symbol representing the cosmic energy of creation and the union of the divine masculine and feminine.",
            //     metaTitle: "Shree Yantra Energy Pyramid - Wealth & Harmony | SacredRelm",
            //     metaDescription: "Shree Yantra Energy Pyramid attracts Prosperity, removes negative energy, balances Vastu, and enhances spiritual growth in homes, offices and devotional spaces.",
            //     focusKeyword: "Shree Yantra Energy Pyramid",
            //     tags: ["Shree Yantra Energy Pyramid", "Shree Yantra Pyramid", "Yantra for home"],
            //     fullDescription: `
            //         The Shree Yantra Energy Pyramid is a sacred geometric tool known for its powerful spiritual significance and energy balancing properties. This beautifully crafted pyramid features the Shree Yantra, one of the most revered symbols in Hindu spirituality, representing the divine cosmic energy and the harmony of the universe.
            //         ##What is the Shree Yantra?
            //         The Shree Yantra is a complex geometric design made up of nine interlocking triangles that radiate from a central point (bindu). These triangles symbolize the union of masculine and feminine divine energies, representing the creation of the cosmos and the path to spiritual enlightenment. It is considered a source of prosperity, success, and spiritual awakening.

                
            //     `,
            //     benefits: [
            //         "Attracts Prosperity: Encourages financial growth and abundance",
            //         "Spiritual Well-being: Promotes inner peace and spiritual clarity",
            //         "Balanced Energy: Harmonizes the energies in your surroundings, fostering a peaceful environment",
            //         "Protects Against Negativity: Acts as a shield against negative influences and energies",
            //         "Improves Focus & Concentration: Ideal for spiritual rituals, meditation, or mindfulness practices to deepen concentration"
            //     ],
            //     howToUse: [
            //         "Place the pyramid facing East or North in your home or office to maximize its effects.",
            //         "Use it as a focal point during meditation or prayer.",
            //         "Keep it on your work desk to invite success and clarity in your professional life.",
            //         "Gift it to loved ones during festivals, housewarmings, or spiritual celebrations as a symbol of good fortune."
            //     ],
            //     faqs: [
            //         {
            //             question: "What is a Shree Yantra Energy Pyramid?",
            //             answer: "It is a pyramid-shaped spiritual tool featuring the sacred Shree Yantra symbol, used to attract prosperity, balance energy, and enhance spiritual growth."
            //         },
            //         {
            //             question: "How does the Shree Yantra Pyramid work?",
            //             answer: "The pyramid shape amplifies energy, while the Shree Yantra's geometry attracts positive vibrations, prosperity, and removes negative energy."
            //         },
            //         {
            //             question: "Where should I place the Shree Yantra Pyramid?",
            //             answer: "Place it facing east or north in your home, office, or meditation space for maximum benefits."
            //         },
            //         {
            //             question: "Can I use it during meditation?",
            //             answer: "Yes, it helps improve focus, deepen meditation, and enhance spiritual connection."
            //         },
            //         {
            //             question: "How do I clean and maintain the pyramid?",
            //             answer: "Wipe it gently with a soft, dry cloth and avoid harsh chemicals or water. Occasionally place it in indirect sunlight to recharge energy."
            //         }
            //     ],
            //     reviews: [
            //         {
            //         id: 1,
            //         user: "Malathi Krishnamurthy",
            //         rating: 5,
            //         date: "2024-09-25",
            //         comment: "Pyramid shape with Shree Yantra is very powerful! I meditate in front of it daily. Concentration improved a lot. Spiritual growth is happening beautifully!"
            //         },
            //         {
            //         id: 2,
            //         user: "Ravi Sundaresan",
            //         rating: 4.7,
            //         date: "2024-08-18",
            //         comment: "Placed this energy pyramid in my cabin after company was facing losses. Now situation is improving. Stress levels also reduced. Very effective tool!"
            //         },
            //         {
            //         id: 3,
            //         user: "Neha Desai",
            //         rating: 5,
            //         date: "2024-12-10",
            //         comment: "This Orgonite Shree Yantra Pyramid has created a calm, peaceful vibe in my living room. It's beautifully made and feels very powerful."
            //         },
            //         {
            //         id: 4,
            //         user: "Prakash Iyer",
            //         rating: 4.5,
            //         date: "2024-11-02",
            //         comment: "Good quality pyramid with a well-embedded Shree Yantra. I feel more focused and energetic at work since placing it on my desk."
            //         },
            //         {
            //         id: 5,
            //         user: "Sneha Rathi",
            //         rating: 4.5,
            //         date: "2024-10-19",
            //         comment: "The pyramid radiates positive vibes. It has uplifted the energy of my meditation corner."
            //         }
            //     ]
            // }